<template>
  <v-container editquoteDetails grid-list-xl style="margin-left:3%; margin-right:3%; max-width: 94%;">
    <center v-if="spineLoading == true">
      <h2 style="margin-top: 50px;">Loading Articles and Synchronising with Store<span style="display: block; margin-top: 20px; font-size: 12px">Please Wait</span></h2>
    </center>

    <v-tabs v-model="activeTab" v-if="spineLoading== false && showSpec == false" slider-color="grey">
      <v-tab class="tab" :key="1" ripple>Quote Details</v-tab>
      <v-tab class="tab" :disabled="!fncCanShowSpecDetails(globalModalParams.details)" :key="2" ripple>Spec Details</v-tab>
      <v-tab class="tab" v-if="isTallisman == true" :key="3" ripple>Delivery Address</v-tab>
      <v-tab class="tab" v-if="isTallisman == true" :key="4" ripple>Order Notes</v-tab>
      <v-tab class="tab" v-if="isTallisman == true" :key="5" ripple>Account Details</v-tab>
      <v-tab-item class="pl-4 pr-4 pt-2 pb-4" :key="1" style="margin-left:0px !important">
        <v-container grid-list-xl style="max-width:100% !important; width:100% !important;margin-left:0px !important">
          <span style="font-weight: bold;font-size: 12px;margin-right: 10px;">ADD LINE ITEM:</span>
          <v-btn ref="addButton" class="addproduct text-xs-right" v-if="this.spineLoading == false && this.loadedDepartment.can_add_rows == 1" @click.stop="fncAddRow()"><i class="material-icons">add</i> Article/Product</v-btn>
          <v-btn class="addproduct text-xs-right" v-if="this.spineLoading == false && this.loadedDepartment.can_add_rows == 1 && isTallisman == true" @click.stop="fncAddInstallationTallisman('delivery')"><i class="material-icons">add</i> Delivery</v-btn>
          <v-btn class="addproduct text-xs-right" v-if="this.spineLoading == false && this.loadedDepartment.can_add_rows == 1 && isTallisman == true" @click.stop="fncAddFuelTallisman()"><i class="material-icons">add</i> Fuel ( No VAT )</v-btn>
          <v-btn class="addproduct text-xs-right" v-if="this.spineLoading == false && this.loadedDepartment.can_add_rows == 1 && isTallisman == true" @click.stop="fncAddInstallationTallisman('fuel')"><i class="material-icons">add</i> Fuel ( VAT )</v-btn>
          <v-btn class="addproduct text-xs-right" v-if="this.spineLoading == false && this.loadedDepartment.can_add_rows == 1 && isTallisman == true" @click.stop="fncAddInstallationTallisman('consumable')"><i class="material-icons">add</i> Consumables</v-btn>
          <v-data-table v-if="spineLoading == false" :search="search" :headers="headers" :items="globalModalParams.details" class="middleTable minTable editTable quoteEditTable" disable-initial-sort style="width:100%;font-size: 10px;" hide-actions>
            <template slot="items" slot-scope="props" class="test" v-if="props.item.deleted == false">
              <tr :class="fncGetClass(props.item)">
                <td class="calculator-field non-input-field" v-if="fncShowRow('calculator') && fncNotInstall(props.item) == true">
                  <span v-if="fncIsCalcDisabled( props.item ) == true" v-html="fncGetCalcName(props.item.calculator)"></span>
                  <v-select v-else label="Search" @input="fncFilterIndexItems( props.index, props.item.calculator )" :items="departmentRangesListFiltered" v-model="props.item.calculator" item-value="id32" item-text="name" autocomplete solo></v-select>
                </td>
                <td class="calculator-field non-input-field" v-if="fncShowRow('calculator') && fncNotInstall(props.item) == false"></td>
                <td class="location-field non-input-field" v-if="fncShowRow('location')">
                  <v-select class="setLocation" label="Set Location" @input="fncSetLocation(props.index, props.item)" :items="fncGetLocations()" v-model="props.item.location_drop" item-value="name" item-text="name" autocomplete solo></v-select>
                </td>

                <td class="vendor-field non-input-field" v-if="fncShowRow('vendor')" v-html="fncGetVendor(props.item)"></td>
                <td class="articledesc-field non-input-field" v-if="fncShowRow('articleDescription') && props.item.m2m == true && !fncIsConsumable(props.item) && !fncIsFuelVat(props.item) && !fncIsDelivery(props.item) && props.item.bw_code != '751226' && props.item.bw_code != '000000000000751226' && props.item.bw_code != '751229' && props.item.bw_code != '000000000000751229' && props.item.bw_code != '787515' && props.item.bw_code != '000000000000787515'">
                  <v-select class="filterArticles" style="margin-bottom: 4px;" label="Filter Articles By" @input="fncSetProductCode( props.index, props.item, props.item.filter )" :items="fncFinalItemsFilteredFilter( props.item.is_install, props.item.calculator )" v-model="props.item.filter" item-value="id" item-text="name" autocomplete solo></v-select>
                  <v-select label="Search" @input="fncSetProductCode( props.index, props.item )" :items="fncFinalItemsFiltered( props.item.is_install, props.item.calculator, true, props.item.filter, props.index )" v-model="props.item.name" item-value="article_description" item-text="article_description_vendor" autocomplete solo></v-select>
                </td>
                <td class="articledesc-field non-input-field" v-if="fncShowRow('articleDescription') && isTallisman != true && !fncIsDelivery(props.item) && props.item.m2m == false && props.item.edit_current == true">
                  <v-select class="filterArticles" style="margin-bottom: 4px;" label="Filter Articles By" @input="fncSetProductCode( props.index, props.item, props.item.filter )" :items="fncFinalItemsFilteredFilter( props.item.is_install, props.item.calculator )" v-model="props.item.filter" item-value="id" item-text="name" autocomplete solo></v-select>
                  <v-select label="Search" @input="fncSetProductCode( props.index, props.item )" :items="fncFinalItemsFiltered( props.item.is_install, props.item.calculator, false, props.item.filter, props.index )" v-model="props.item.calc_name" item-value="article_value" item-text="article_description_vendor" autocomplete solo></v-select>
                </td>
                <td class="articledesc-field non-input-field" v-if="fncShowRow('articleDescription') && isTallisman != true && !fncIsDelivery(props.item) && props.item.m2m == false && ( props.item.edit_current == false || props.item.edit_current == undefined )">
                  {{ props.item.name }}
                </td>
                <!--<td class="articledesc-field non-input-field" v-if="fncShowRow('articleDescription') && isTallisman == true && props.item.bw_code != '751226' && props.item.bw_code != '000000000000751226' && props.item.bw_code != '751229' && props.item.bw_code != '000000000000751229'">
                  <v-select label="Search" @input="fncSetProductCode( props.index, props.item )" :items="fncFinalItemsFiltered( props.item.is_install, props.item.calculator, true )" v-model="props.item.name" item-value="article_value" item-text="article_description_vendor" autocomplete solo></v-select>
                </td>-->
                <td class="articledesc-field non-input-field" v-if="fncShowRow('articleDescription') && !fncIsConsumable(props.item) && fncIsDelivery(props.item)">
                  Delivery
                </td>
                <td class="articledesc-field non-input-field" v-if="fncShowRow('articleDescription') && fncIsConsumable(props.item)">
                  Consumables
                </td>
                <td class="articledesc-field non-input-field" v-if="fncShowRow('articleDescription') && fncIsFuelVat(props.item)">
                  Talisman Fuel - VAT
                </td>
                <td class="articledesc-field non-input-field" v-if="fncShowRow('articleDescription') && !fncIsDelivery(props.item) && isTallisman == true && ( props.item.bw_code == '751226' || props.item.bw_code == '000000000000751226' || props.item.bw_code == '751229' || props.item.bw_code == '000000000000751229' || props.item.bw_code == '787515' || props.item.bw_code == '000000000000787515' )">
                  {{ props.item.name }}
                </td>
                <td class="articledesc-field non-input-field" v-if="fncShowRow('articleDescription') && !fncIsDelivery(props.item) && isTallisman == true && props.item.added_from_screen == undefined && ( props.item.bw_code == '751223' || props.item.bw_code == '706223587' || props.item.bw_code == '000000000000751223' || props.item.bw_code == '000000000706223587' )">
                  {{ props.item.name }}
                </td>
                <td class="article-field non-input-field" v-if="fncShowRow('bwArticleNo') && props.item.m2m == true && props.item.calc_name == ''">
                  <v-text-field v-model="props.item.bw_code" solo></v-text-field>
                  <v-btn class="install-btn" color="success" @click="fncAddInstallation(props.index)" style="display:block;" v-if="isTallisman == false && fncNotInstall(props.item.code) && installed == false && props.item.bw_code != '' && props.item.bw_code != '000000000000000000' && canInstall == true && ( props.item.is_install == undefined || props.item.is_install == false ) && fncCanInstall(props.index)">Install this product</v-btn>
                </td>
                <td class="article-field non-input-field" v-if="fncShowRow('bwArticleNo') && ( props.item.m2m == false || props.item.calc_name != '' )">
                  {{ parseInt(props.item.bw_code) }}

                  <v-btn class="install-btn" color="success" @click="fncAddInstallation(props.index)" style="display:block;" v-if="isTallisman == false && fncHasInstall(props.item.is_install) && fncNotInstall(props.item.code) && installed == false && props.item.bw_code != '' && props.item.bw_code != '000000000000000000' && canInstall == true && ( props.item.is_install == undefined || props.item.is_install == false ) && fncCanInstall(props.index)">Install this product</v-btn>
                </td>
                <td class="non-input-field" v-if="fncShowRow('plantCode') && props.item.bw_code != '787515' && props.item.bw_code != '000000000000787515' && !fncIsConsumable(props.item) && !fncIsDelivery(props.item) && !fncIsFuelVat(props.item) && !fncIsConsumable(props.item)">
                  <v-select label="Code" :items="fncVendorCodes( props.item.bw_code )" @input="fncSetVendorDescription( props.index, props.item.bw_code, props.item.vendor_code )" v-model="props.item.vendor_code" item-value="name" item-text="name" autocomplete solo></v-select>
                </td>
                <td class="non-input-field" v-if="fncShowRow('plantCode') && ( props.item.bw_code == '787515' || props.item.bw_code == '000000000000787515' )">
                  Talisman Fuel
                </td>
                <td v-html="fncSetCodeDescription(props.item)" class="non-input-field" v-if="fncCheckCodeDescription(props.item) && fncShowRow('plantCode') && ( props.item.bw_code == '751225' || props.item.bw_code == '000000000000751225' )"></td>

                <td class="productdesc-field non-input-field" v-if="fncShowRow('productDescription') && isTallisman == false && props.item.m2m == true"><v-text-field :maxlength="30" :counter="30" textarea rows="2" v-model="props.item.name_sub" solo></v-text-field></td>
                <td class="productdesc-field non-input-field" v-if="fncShowRow('productDescription') && isTallisman == false && props.item.m2m == false">{{ props.item.name_sub }}</td>
                <td class="productdesc-field non-input-field" v-if="fncShowRow('productDescription') && !fncIsFuelVat(props.item) && !fncIsDelivery(props.item) && isTallisman == true"><v-text-field :maxlength="30" :counter="30" textarea rows="2" v-model="props.item.name_sub" solo></v-text-field></td>
                <td class="productdesc-field non-input-field" v-if="fncShowRow('productDescription') && !fncIsConsumable(props.item) && !fncIsFuelVat(props.item) && fncIsDelivery(props.item) && isTallisman == true">Delivery</td>
                <td class="productdesc-field non-input-field" v-if="fncShowRow('productDescription') && fncIsFuelVat(props.item) && isTallisman == true">Fuel Mix – WITH VAT</td>
                <td class="quantity-field non-input-field text-xs-right" v-if="fncShowRow('quantity') && fncInputQty(props.item) == true"><v-text-field @input="fncCanSave(props.index, 'qty')" solo single-line type="number" v-model="props.item.quantity"></v-text-field></td>
                <td class="quantity-field non-input-field text-xs-right" v-if="fncShowRow('quantity') && fncInputQty(props.item) == false">{{ props.item.quantity }}</td>
                <td class="uom-field non-input-field" v-if="fncShowRow('uom')" v-html="fncFormatUom(props.item)"></td>


                <td class="hire-field" v-if="fncShowRow('hireDate') && fncCheckChildRow( props.item )">
                  <date-picker @input="fncCheckHireDays(props.index, 'hire_date_start')" style="display: block;float:left;" v-model="props.item.hire_date_start" format="YYYY-MM-DD" lang="en"></date-picker>
                  <span style="padding-left:10px;padding-right:10px;padding-top:10px;display:block;float:none !important;">to</span>
                  <date-picker @input="fncCheckHireDays(props.index, 'hire_date_end')" style="display: block;float:left;" v-model="props.item.hire_date_end" format="YYYY-MM-DD" lang="en"></date-picker>
                </td>
                <td v-if="fncShowRow('hireDate') && !fncCheckChildRow( props.item )">&nbsp;</td>
                <td v-if="fncShowRow('hirePeriod') && fncCheckChildRow( props.item )" class="hirePeriod">
                  <div><span style="display: inline-block;">Day/s:</span><v-text-field disabled=""true @input="fncCanSave(props.index)" style="display: inline-block; margin: 0; width: auto !important" solo single-line v-model="props.item.hire_period" :min="fncHirePeriodMin( props.index )" :max="fncHirePeriodMax( props.index )" type="number" step="0.5"></v-text-field></div>
                  <a v-if="fncCanDecrease(props.index)" @click="fncUpdateDays('descrease', props.index)" class="remove-half"><small><i class="material-icons">remove</i> half day</small></a>
                  <a v-if="fncCanIncrease(props.index)" @click="fncUpdateDays('increase', props.index)" class="add-half"><small><i class="material-icons">add</i> half day</small></a>
                </td>
                <td v-if="fncShowRow('hirePeriod') && !fncCheckChildRow( props.item )">&nbsp;</td>
                <td v-if="fncShowRow('deliveryMethod') && fncCheckChildRow( props.item )" class="text-xs-right centerText">
                  <v-select label="Select" :items="collectDeliver" v-model="props.item.delivery_method" item-value="name" item-text="name" autocomplete solo></v-select>
                </td>
                <td v-if="fncShowRow('deliveryMethod') && !fncCheckChildRow( props.item )">&nbsp;</td>
                <td v-if="fncShowRow('receivalTime') && fncCheckChildRow( props.item )" class="text-xs-right centerText">
                  <v-select label="Select" :items="receival" v-model="props.item.receival_time" item-value="name" item-text="name" autocomplete solo></v-select>
                </td>
                <td v-if="fncShowRow('receivalTime') && !fncCheckChildRow( props.item )">&nbsp;</td>


                <td class="text-xs-right non-input-field min-input-field" v-if="fncShowRow('unitSellingPriceExVat') && fncInputEx(props.item) == false" v-html="fncFormatNumber(props.item.price_ex)"></td>
                <td class="text-xs-right non-input-field min-input-field" v-if="fncShowRow('unitSellingPriceExVat') && fncInputEx(props.item) == true"><span style="padding-top: 8px;display: inline-block; float:left;">R</span>&nbsp;<v-text-field @input="fncCanSave(props.index, 'sales')" class="popupPrice" solo single-line v-model="props.item.price_ex" type="number"></v-text-field></td>
                <td class="text-xs-right non-input-field" v-if="fncShowRow('unitVat')" v-html="fncFormatNumber(props.item.vat, props.item.bw_code)"></td>
                <td class="text-xs-right non-input-field" v-if="fncShowRow('unitTotalIncVat')" v-html="fncGetUnitTotal(props.item, props.item.bw_code)"></td>

                <td class="text-xs-right non-input-field min-input-field" v-if="fncShowRow('vendorUnitCostExVat') && fncInputEx(props.item) == true"><v-text-field @input="fncCanSave(props.index,'cost')" type="number" :disabled="fncIsDisabledCost(props.item)" solo single-line v-model="props.item.cost_price"></v-text-field></td>
                <td class="text-xs-right non-input-field" v-if="fncShowRow('vendorUnitCostExVat') && fncInputEx(props.item) == false" v-html="fncGetCalcCost( props.index, props.item )"></td>

                <td class="margin-field text-xs-right non-input-field" v-if="fncShowRow('margin') && fncInputEx(props.item) == true"><v-text-field type="number" @input="fncCanSave(props.index, 'margin')" style="display:inline-block; width: 75%;padding-right: 10px;" :disabled="fncIsDisabledMargin(props.item)" solo single-line v-model="props.item.markup"></v-text-field>&nbsp;<span style="display: inline-block;">%</span></td>
                <td class="margin-field text-xs-right non-input-field" v-if="fncShowRow('margin') && fncInputEx(props.item) == false" v-html="fncGetCalcMargin(props.index, props.item)"></td>
                <td class="text-xs-right non-input-field" v-if="fncShowRow('totalIncVat')" v-html="fncGetTotal(props.item, props.item.bw_code)"></td>
                <td width="5%" class="delete-field non-input-field"><a v-bind="props" @click.prevent="fncDeleteItemRow(props.index, props.item)"><i class="material-icons">delete_forever</i></a></td>

              </tr>
            </template>
          </v-data-table>

          <v-btn class="text-xs-right" style="margin-top: 1% !important;float: right;background: #333;color: #fff;margin-right: 0% !important;" @click.stop="fncAddRow()">Add Row</v-btn>
          <!--<v-btn class="text-xs-right" style="margin-top: 1% !important;float: right;background: #333;color: #fff;margin-right: 0.5% !important;" v-if="isTallisman == true && fncCanDelivery()" @click.stop="fncAddDeliveryRow()">Add Delivery Fee</v-btn>-->
          <!--<div v-if="isTallisman == true" v-html="fncShowSummary()"></div>-->
        </v-container>
      </v-tab-item>
      <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="2">
        <div style="margin: 1%;" class="specDetails" v-html="fncShowSpecDetails(globalModalParams.details)"></div>
      </v-tab-item>
      <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="3">
        <v-container grid-list-xl style="padding-top: 10px !important;margin-left: 0px;">
          <v-layout row wrap style="margin-left: 0px;">
            <v-flex lg6>
              <label class="blackLabel">Street No. and Name</label>
              <v-text-field placeholder="Street No. and Name" v-model="addressOne" single-line solo></v-text-field>
            </v-flex>
            <v-flex lg6>
              <label class="blackLabel">Complex Name and No.</label>
              <v-text-field placeholder="Complex Name and No." v-model="addressTwo" single-line solo></v-text-field>
            </v-flex>
            <v-flex lg6>
              <label class="blackLabel">Town</label>
              <v-text-field placeholder="Town" v-model="town" single-line solo></v-text-field>
            </v-flex>
            <v-flex lg6>
              <label class="blackLabel">Province</label>
              <v-text-field placeholder="Province" v-model="province" single-line solo></v-text-field>
            </v-flex>
            <v-flex lg6>
              <label class="blackLabel">Postal Code</label>
              <v-text-field placeholder="Postal Code" v-model="postalCode" single-line solo></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-tab-item>
      <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="4">
        <v-container grid-list-xl style="padding-top: 10px !important;margin-left: 0px;">
          <v-layout row wrap style="margin-left: 0px;">
            <v-flex lg12>
              <label class="blackLabel">Delivery Special Instructions</label>
              <v-text-field placeholder="Specific time, directions etc." v-model="notes" multi-line solo></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-tab-item>
      <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="5">
        <v-container grid-list-xl style="padding-top: 10px !important;margin-left: 0px;">
          <v-layout row wrap style="margin-left: 0px;">
            <v-flex lg6>
              <label class="blackLabel">Customer Account Type</label>
              <v-select label="Customer Account Type" :items="customerAccountTypes" v-model="customerAccountType" item-value="name" item-text="name" autocomplete solo></v-select>
              <br />
              <label class="blackLabel">Customer Account Number</label>
              <v-text-field placeholder="Customer Account Number" v-model="customerAccountNumber" single-line solo></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-tab-item>
      <!--<v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="5">
        <v-container grid-list-xl style="padding-top: 10px !important;margin-left: 0px;margin-right:0px;widrth:100%;">
          <v-layout row wrap style="margin-left: 0px;width:100%;">
            <v-flex xs3 style="padding-left:0px !important;">
              <v-text-field append-icon="search" label="Search" solo single-line v-model="search"></v-text-field><br />
            </v-flex>
            <v-flex lg9>
              <v-data-table style="margin-top: 0px;height:50vh;" :search="search" :headers="userHeaders" :items="responsibleReps" hide-actions class="elevation-1 repLinkTable" disable-initial-sort :rows-per-page-items="[20,40,60,80,100]">
                <template slot="items" slot-scope="props">
                  <td width="15%"><v-switch @change="fncSaveResponsibleRep( props.item )" v-model="props.item.checked"></v-switch></td>
                  <td width="45%" v-html="fncExtractData(props.item.name, 0)"></td>
                  <td width="40%" v-html="fncExtractData(props.item.name, 1)"></td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-container>
      </v-tab-item>-->
    </v-tabs>
    <!--<v-data-table v-if="spineLoading == false" :search="search" :headers="headers" :items="globalModalParams.details" class="middleTable minTable editTable quoteEditTable" disable-initial-sort style="width:99%;font-size: 10px;" hide-actions>
      <template slot="items" slot-scope="props" class="test" v-if="props.item.deleted == false">
      <tr :class="fncGetClass(props.item)">
        <td class="calculator-field non-input-field" v-if="fncShowRow('calculator') && fncNotInstall(props.item) == true">
          <span v-if="fncIsCalcDisabled( props.item ) == true" v-html="fncGetCalcName(props.item.calculator)"></span>
          <v-select v-else label="Search" @input="fncFilterIndexItems( props.index, props.item.calculator )" :items="departmentRangesListFiltered" v-model="props.item.calculator" item-value="id32" item-text="name" autocomplete solo></v-select>
        </td>
        <td class="calculator-field non-input-field" v-if="fncShowRow('calculator') && fncNotInstall(props.item) == false"></td>
        <td class="location-field non-input-field" v-if="fncShowRow('location')">
          <v-select class="setLocation" label="Set Location" @input="fncSetLocation(props.index, props.item)" :items="fncGetLocations()" v-model="props.item.location_drop" item-value="name" item-text="name" autocomplete solo></v-select>
        </td>

        <td class="vendor-field non-input-field" v-if="fncShowRow('vendor')" v-html="fncGetVendor(props.item)"></td>
]
        <td class="articledesc-field non-input-field" v-if="fncShowRow('articleDescription') && props.item.m2m == true">
          <v-select label="Search" @input="fncSetProductCode( props.index, props.item )" :items="fncFinalItemsFiltered( props.item.is_install, props.item.calculator )" v-model="props.item.name" item-value="article_description" item-text="article_description_vendor" autocomplete solo></v-select>
        </td>
        <td class="articledesc-field non-input-field" v-if="fncShowRow('articleDescription') && isTallisman != true && props.item.m2m == false && props.item.edit_current == true">
          <v-select label="Search" @input="fncSetProductCode( props.index, props.item )" :items="fncFinalItemsFiltered( props.item.is_install, props.item.calculator )" v-model="props.item.calc_name" item-value="article_value" item-text="article_description_vendor" autocomplete solo></v-select>
        </td>
        <td class="articledesc-field non-input-field" v-if="fncShowRow('articleDescription') && isTallisman != true && props.item.m2m == false && ( props.item.edit_current == false || props.item.edit_current == undefined )">
          {{ props.item.name }}
        </td>
        <td class="articledesc-field non-input-field" v-if="fncShowRow('articleDescription') && isTallisman == true">
          {{ props.item.name }}
        </td>
        <td class="article-field non-input-field" v-if="fncShowRow('bwArticleNo') && props.item.m2m == true && props.item.calc_name == ''">
          <v-text-field v-model="props.item.bw_code" solo></v-text-field>
          <v-btn class="install-btn" color="success" @click="fncAddInstallation(props.index)" style="display:block;" v-if="fncNotInstall(props.item.code) && installed == false && props.item.bw_code != '' && props.item.bw_code != '000000000000000000' && canInstall == true && ( props.item.is_install == undefined || props.item.is_install == false ) && fncCanInstall(props.index)">Install this product</v-btn>
        </td>
        <td class="article-field non-input-field" v-if="fncShowRow('bwArticleNo') && ( props.item.m2m == false || props.item.calc_name != '' )">
          {{ parseInt(props.item.bw_code) }}
          <v-btn class="install-btn" color="success" @click="fncAddInstallation(props.index)" style="display:block;" v-if="fncHasInstall(props.item.is_install) && fncNotInstall(props.item.code) && installed == false && props.item.bw_code != '' && props.item.bw_code != '000000000000000000' && canInstall == true && ( props.item.is_install == undefined || props.item.is_install == false ) && fncCanInstall(props.index)">Install this product</v-btn>
        </td>
        <td class="productdesc-field non-input-field" v-if="fncShowRow('productDescription') && isTallisman == false && props.item.m2m == true"><v-text-field textarea rows="2" v-model="props.item.name_sub" solo></v-text-field></td>
        <td class="productdesc-field non-input-field" v-if="fncShowRow('productDescription') && isTallisman == false && props.item.m2m == false">{{ props.item.name_sub }}</td>
        <td class="productdesc-field non-input-field" v-if="fncShowRow('productDescription') && isTallisman == true"><v-text-field textarea rows="2" v-model="props.item.name_sub" solo></v-text-field></td>
        <td class="quantity-field non-input-field text-xs-right" v-if="fncShowRow('quantity') && fncInputQty(props.item) == true"><v-text-field @input="fncCanSave(props.index, 'qty')" solo single-line type="number" v-model="props.item.quantity"></v-text-field></td>
        <td class="quantity-field non-input-field text-xs-right" v-if="fncShowRow('quantity') && fncInputQty(props.item) == false">{{ props.item.quantity }}</td>
        <td class="uom-field non-input-field" v-if="fncShowRow('uom')" v-html="fncFormatUom(props.item)"></td>


        <td v-if="fncShowRow('hireDate') && fncCheckChildRow( props.item )">
          <date-picker @input="fncCheckHireDays(props.index, 'hire_date_start')" style="display: block;float:left;" v-model="props.item.hire_date_start" format="YYYY-MM-DD" lang="en"></date-picker>
          <span style="padding-left:10px;padding-right:10px;padding-top:10px;display:block;float:none !important;">to</span>
          <date-picker @input="fncCheckHireDays(props.index, 'hire_date_end')" style="display: block;float:left;" v-model="props.item.hire_date_end" format="YYYY-MM-DD" lang="en"></date-picker>
        </td>
        <td v-if="fncShowRow('hireDate') && !fncCheckChildRow( props.item )">&nbsp;</td>
        <td v-if="fncShowRow('hirePeriod') && fncCheckChildRow( props.item )" :style="{ background: props.item.colour }" class="text-xs-right centerText">
          <v-text-field @input="fncCanSave(props.index)" style="display: block; float: left; margin-right: 5px;" solo single-line v-model="props.item.hire_period" :min="fncHirePeriodMin( props.index )" :max="fncHirePeriodMax( props.index )" type="number" step="0.5" style="float:left;padding-top: 10px; width:60% !important"></v-text-field> <span style="display: inline-block; float: left; padding-left: 10px; padding-top: 10px">day/s</span>
        </td>
        <td v-if="fncShowRow('hirePeriod') && !fncCheckChildRow( props.item )">&nbsp;</td>
        <td v-if="fncShowRow('deliveryMethod') && fncCheckChildRow( props.item )" :style="{ background: props.item.colour }" class="text-xs-right centerText">
          <v-select label="Select" :items="collectDeliver" v-model="props.item.delivery_method" item-value="name" item-text="name" autocomplete solo></v-select>
        </td>
        <td v-if="fncShowRow('deliveryMethod') && !fncCheckChildRow( props.item )">&nbsp;</td>
        <td v-if="fncShowRow('receivalTime') && fncCheckChildRow( props.item )" :style="{ background: props.item.colour }" class="text-xs-right centerText">
          <v-select label="Select" :items="receival" v-model="props.item.receival_time" item-value="name" item-text="name" autocomplete solo></v-select>
        </td>
        <td v-if="fncShowRow('receivalTime') && !fncCheckChildRow( props.item )">&nbsp;</td>


        <td class="text-xs-right non-input-field" v-if="fncShowRow('unitSellingPriceExVat') && fncInputEx(props.item) == false" v-html="fncFormatNumber(props.item.price_ex)"></td>
        <td class="text-xs-right non-input-field" v-if="fncShowRow('unitSellingPriceExVat') && fncInputEx(props.item) == true"><span style="padding-top: 8px;display: inline-block; float:left;">R</span>&nbsp;<v-text-field @input="fncCanSave(props.index, 'sales')" class="popupPrice" solo single-line v-model="props.item.price_ex"></v-text-field></td>
        <td class="text-xs-right non-input-field" v-if="fncShowRow('unitVat')" v-html="fncFormatNumber(props.item.vat)"></td>
        <td class="text-xs-right non-input-field" v-if="fncShowRow('unitTotalIncVat')" v-html="fncGetUnitTotal(props.item)"></td>

        <td class="text-xs-right non-input-field" v-if="fncShowRow('vendorUnitCostExVat') && fncInputEx(props.item) == true"><v-text-field @input="fncCanSave(props.index,'cost')" :disabled="fncIsDisabledCost(props.item)" solo single-line v-model="props.item.cost_price"></v-text-field></td>
        <td class="text-xs-right non-input-field" v-if="fncShowRow('vendorUnitCostExVat') && fncInputEx(props.item) == false" v-html="fncGetCalcCost( props.index, props.item )"></td>

        <td class="margin-field text-xs-right non-input-field" v-if="fncShowRow('margin') && fncInputEx(props.item) == true"><v-text-field @input="fncCanSave(props.index, 'margin')" style="display:inline-block; width: 75%;" :disabled="fncIsDisabledMargin(props.item)" solo single-line v-model="props.item.markup"></v-text-field>&nbsp;<span style="display: inline-block;">%</span></td>
        <td class="margin-field text-xs-right non-input-field" v-if="fncShowRow('margin') && fncInputEx(props.item) == false" v-html="fncGetCalcMargin(props.index, props.item)"></td>
        <td class="text-xs-right non-input-field" v-if="fncShowRow('totalIncVat')" v-html="fncGetTotal(props.item)"></td>
        <td width="5%" class="delete-field non-input-field"><a v-bind="props" @click.prevent="fncDeleteItemRow(props.index, props.item)"><i class="material-icons">delete_forever</i></a></td>

</tr>
      </template>
    </v-data-table>-->
    <div v-if="isTallisman == true && spineLoading == false && activeTab == '0'" v-html="fncShowSummary()"></div>
    <div v-if="spineLoading == false && showLocationAdd == true" class="addLocation">
      <div class="locationHeading">
        <h4>Create New Location</h4>
        <v-btn style="background-color: #F5F5F5 !important;" class="text-xs-right" @click.stop="showLocationAdd = false">Cancel</v-btn>
        <v-btn style="background-color: #F5F5F5 !important;" class="text-xs-right" @click.stop="fncSaveLocation()">Save and Close</v-btn>
      </div>
      <div class="locationBody">
        <v-text-field v-model="newLocationName" solo></v-text-field>
      </div>
    </div>
    <div class="quotePopupTotals" v-if="isTallisman == false && spineLoading == false && activeTab == '0'" style="clear:right">
      <table class="quotePopupSummary" style="border: none !important">
        <tr>
          <td style="border-right:none !important;font-size:14px;border-bottom: 3px double #000 !important; border-top: 1px solid #000 !important;"><strong>Total (Incl VAT)</strong></td>
          <td style="border:none !important;font-size:14px; text-align: right;" v-html="fncGetFinalTotal()"></td>
        </tr>
        <tr>
          <td colspan="2" style="font-size:11px;text-align: right; border:none !important;font-size:10px;"><span v-html="fncGetTotalVat()"></span></td>
        </tr>
      </table>
    </div>
    <v-layout wrap>
      <div class="pl-4 pr-4 pb-4 buttonHolder">
        <div style="float: right">
          <v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Cancel<i class="material-icons">close</i></v-btn>
          <v-btn v-if="isDisabled == 'true'" class="text-xs-right saveandclose" @click.stop="fncSaveItems()"><i class="material-icons">save</i>Save and Close</v-btn>
          <v-btn v-if="isDisabled == 'false'" disabled="true" class="text-xs-right buttonForDisable saveandclose" @click.stop="fncSaveItems()"><i class="material-icons">save</i>Save and Close</v-btn>
          <v-progress-circular indeterminate :width="3" :size="20" v-if="isLoading == true" color="white" class="pt-3 loginLoader"></v-progress-circular>
          <v-btn v-if="isDisabled == 'true' && isLoading == false" class="text-xs-right saveanddownload" @click.stop="fncPreviewPdf"><i class="material-icons">download</i>Save and Download PDF</v-btn>
          <v-btn v-if="isDisabled == 'false' && isLoading == false" class="text-xs-right saveanddownload" disabled=""true><i class="material-icons">download</i>Save and Download PDF</v-btn>
          <v-btn v-if="isDisabled == 'true' && isLoading == false" class="text-xs-right sendtotrolley" color="success" @click.stop="fncSendToHybrisTrolley"><i class="material-icons">trolley</i>Send To Customer Trolley</v-btn>
          <v-btn v-if="isDisabled == 'false' && isLoading == false" disabled="true" class="text-xs-right sendtotrolley" color="success"><i class="material-icons">trolley</i>Send To Customer Trolley</v-btn>
          <!--<v-btn class="text-xs-right showspec" @click.stop="fncShowSpec()" v-if="showSpec == false && fncCanShowSpecDetails(globalModalParams.details)"><i class="material-icons">list</i>Show Spec</v-btn>-->
          <v-btn class="text-xs-right showquote" @click.stop="fncHideSpec()" v-if="showSpec == true"><i class="material-icons">list</i>Show Quote</v-btn>
        </div>
      </div>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex';
  import DatePicker from 'vue2-datepicker'
  import {singleQuoteData} from "../../../store/modules/reports/getters";
  export default {
    name: 'Settings',
    data() {
      return {
        objUser: 0,
        /*productCodesSet: [
          '000000000000728474', '000000000000728490', '000000000000728486',
          '000000000000728492', '000000000000728494', '000000000000728487', '000000000000728488',
          '000000000000728495'
        ],*/
        canInstall: true,
        showSpec: false,
        productCodesSet: [],
        search: '',
        totalNett: 0,
        totalVat: 0,
        totals: [],
        linkedProps: [],
        newSingleQuoteData: [],
        lineData: '',
        productCount: 0,
        quoteTotal: [],
        addedSpecs: [],
        isDisabled: 'true',
        departmentRangesListFiltered: [],
        headers: [
          /*{ text: 'Article Description', value: 'name', width: '14%' },
          { text: 'BW Article No', value: 'name', width: '12%' },
          { text: 'Vendor', value: 'name', width: '10%' },
          { text: 'Product Description', value: 'name', width: '14%' },
          { text: 'Quantity', value: 'name', width: '5%' },
          { text: 'Unit Selling Price (ex VAT)', value: 'edit', width: '15%' },
          { text: 'Unit VAT', value: 'name', width: '5%' },
          { text: 'Vendor Unit Cost ( Excl VAT )', value: 'edit', width: '15%' },
          { text: 'Margin', value: 'name', width: '5%' },
          { text: 'Delete', value: 'name', width: '5%' }*/
          /*{ text: 'BW Article No', value: 'name', width: '15%' },
          { text: 'Quantity', value: 'created_on', width: '10%' },
          { text: 'Vendor', value: 'created_on', width: '10%' },
          { text: 'Product Description', value: 'created_on', width: '10%' },
          { text: 'Total Selling Price ( Excl VAT )', value: 'edit', width: '8%' },
          { text: 'VAT', value: 'edit', width: '8%' },
          { text: 'Vendor Cost Price ( Excl VAT )', value: 'edit', width: '9%' },
          { text: 'Markup', value: 'edit', width: '5%' },
          { text: 'Delete', value: 'delete', width: '5%' }*/
        ],
        finalPlistItems: [],
        isLoading: false,
        departmentMargin: 0,
        departmentInstallationMargin: 0,
        installed: false,
        productCodes: [],
        loadedDepartment: [],
        itemRefs: [],
        showLocationAdd: false,
        locationAddIndex: 0,
        newLocationName: '',
        collectDeliver: [
          { name: 'Deliver' },
          { name: 'Collect' }
        ],
        receival: [
          { name: 'Morning' },
          { name: 'Afternoon' }
        ],
        isTallisman: false,
        notes: '',
        customerAccountType: 'BWC',
        customerAccountNumber: '',
        addressOne: '',
        addressTwo: '',
        province: '',
        town: '',
        postalCode: '',
        customerAccountTypes: [
          { name: 'BWA' },
          { name: 'BWC' }
        ],
        activeTab: 0,
        rangeFilters: [],
        setFilter: '',
        setIndex: ''
      };
    },
    methods: {
      fncCheckCodeDescription( item ) {

        var lineItemData = JSON.parse( item.line_item_data );

        if( lineItemData.fuel_vat ) {
          return true;
        } else if( lineItemData.consumable ) {
          return true;
        }

        if( this.fncIsDelivery(  item ) ) {
          return true;
        }

        return false;

      },
      fncSetCodeDescription( item ) {

        var lineItemData = JSON.parse( item.line_item_data );

        if( lineItemData.fuel_vat ) {
          return 'Talisman Fuel WITH VAT';
        } else if( lineItemData.consumable ) {
          return 'Consumable';
        }

        return 'DLVRY';

      },
      fncIsDelivery( item ) {

      var lineItemData =  JSON.parse( item.line_item_data );

      if( lineItemData.delivery ) {
        return true;
      }

      return false;

      },
      fncIsConsumable(item) {
        var lineItemData =  JSON.parse( item.line_item_data );

        if( lineItemData.consumable ) {
          return true;
        }

        return false;
      },
      fncIsFuelVat(item) {
        var lineItemData =  JSON.parse( item.line_item_data );

        if( lineItemData.fuel_vat ) {
          return true;
        }

        return false;
      },
      fncCanShowSpecDetails( spec, num ) {

      var addedSpecs = [];
      var addedFinalSpecs = [];
      for( var s in spec ) {
        //addedSpecs.push( spec[s].spec );
        addedSpecs[spec[s].spec] = '';
      }
      var strReturn = '';
      for( var a in addedSpecs ) {
        strReturn += a;
      }
      if( strReturn != '' ) {
        return true
      }
      return false;
    },
    fncShowSpecDetails( spec, num ) {

      var addedSpecs = [];
      var addedFinalSpecs = [];
      for( var s in spec ) {
        //addedSpecs.push( spec[s].spec );
        addedSpecs[spec[s].spec] = '';
      }
      var strReturn = '';
      for( var a in addedSpecs ) {
        strReturn += a;
      }
      return strReturn;
    },
    fncShowSpec() {
      this.showSpec = true;
    },
    fncHideSpec() {
      this.showSpec = false;
    },
    disableToDate(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date > today;
    },
    fncCanDecrease( index ) {

      /*var parseValue = parseFloat( this.globalModalParams.details[index].hire_period );

      /*if(  ) {

      }*/
      /*console.log('Full');
      console.log( parseValue );*/
      /*if(  ) {

      }*/

    },
    fncCanIncrease( index ) {

      var periodString = String( this.globalModalParams.details[index].hire_period );

      if( periodString.indexOf('.5') == -1 ) {
        return true;
      }
      return false;
    },
    fncCanDecrease( index ) {

      var periodString = String( this.globalModalParams.details[index].hire_period );

      if( periodString.indexOf('.5') == -1 ) {
        return false;
      }
      return true;
    },
    fncUpdateDays( type, index ) {

      if( type == 'increase' ) {
        this.globalModalParams.details[index].hire_period = parseFloat(this.globalModalParams.details[index].hire_period) + 0.5;
      } else {
        this.globalModalParams.details[index].hire_period = parseFloat(this.globalModalParams.details[index].hire_period) - 0.5;
      }

    },
    fncSetVendorDescription( index, code, vendorCode ) {

      code = parseInt(code);

      var returnObj = [];

      if( this.lookupArray[code] != undefined ) {

        for( var c in this.lookupArray[code] ) {
          if( this.lookupArray[code][c].code == vendorCode ) {
            var lineItemData = JSON.parse(this.globalModalParams.details[index].line_item_data);
            lineItemData.v_key = this.lookupArray[code][c].v_key;

            this.globalModalParams.details[index].line_item_data = JSON.stringify( lineItemData );
            this.globalModalParams.details[index].name_sub = this.lookupArray[code][c].description.trim();
            this.globalModalParams.details[index].p_key = this.lookupArray[code][c].p_key;
          }
        }
      }

    },
    fncVendorCodes( code ) {

      code = parseInt(code);

      var returnObj = [];

      if( this.lookupArray[code] != undefined ) {
        for( var c in this.lookupArray[code] ) {
          returnObj.push({name: this.lookupArray[code][c].code});
        }
      }

      return returnObj;
    },
    fncSetVendorCode( index, code, description ) {

      code = parseInt(code);

      var returnObj = [];

      if( this.lookupArray[code] != undefined ) {

        for( var c in this.lookupArray[code] ) {
          if( this.lookupArray[code][c].description == description ) {

            var lineItemData = JSON.parse(this.globalModalParams.details[index].line_item_data);
            lineItemData.v_key = this.lookupArray[code][c].v_key;
            this.globalModalParams.details[index].line_item_data = JSON.stringify( lineItemData );

            this.globalModalParams.details[index].vendor_code = this.lookupArray[code][c].code;
            this.globalModalParams.details[index].p_key = this.lookupArray[code][c].p_key;

          }
        }
      }

    },
    fncCanAddDeliveryTallisman() {
      for( var d in this.globalModalParams.details ) {
        if( this.globalModalParams.details[d].deleted == false && ( this.globalModalParams.details[d].bw_code == '000000000000751225' || this.globalModalParams.details[d].bw_code == '751225' || this.globalModalParams.details[d].code == '000000000000751225' || this.globalModalParams.details[d].code == '751225' ) ) {
          return false;
        }
      }
      return true;
    },
    fncCanAddInstallationTallisman() {
      for( var d in this.globalModalParams.details ) {
        if( this.globalModalParams.details[d].deleted == false && ( this.globalModalParams.details[d].bw_code == '000000000000751226' || this.globalModalParams.details[d].bw_code == '751226' || this.globalModalParams.details[d].code == '000000000000751226' || this.globalModalParams.details[d].code == '751226' ) ) {
          return false;
        }
      }
      return true;
    },
    fncCanAddFuelTallisman() {
      for( var d in this.globalModalParams.details ) {
        if( this.globalModalParams.details[d].deleted == false && ( this.globalModalParams.details[d].bw_code == '000000000000787515' || this.globalModalParams.details[d].bw_code == '787515' || this.globalModalParams.details[d].code == '000000000000787515' || this.globalModalParams.details[d].code == '787515' ) ) {
          return false;
        }
      }
      return true;
    },
    fncShowSummary() {

      var totals = [];
      var fullTotals = 0;
      var vatRemove = 0;
      for( var d in this.globalModalParams.details ) {

        this.fncCanSave( d );

        if( this.globalModalParams.details[d].deleted == false ) {

          if( totals[this.globalModalParams.details[d].name] == undefined ) {
            totals[this.globalModalParams.details[d].name] = 0;
          }

            if( this.globalModalParams.details[d].code == '' ) {
              this.globalModalParams.details[d].code = this.globalModalParams.details[d].bw_code;
            }

            if( !this.fncIsConsumable(this.globalModalParams.details[d]) && !this.fncIsFuelVat(this.globalModalParams.details[d]) && !this.fncIsDelivery(this.globalModalParams.details[d]) && ( this.globalModalParams.details[d].code == '000000000000751223' || this.globalModalParams.details[d].code == '751223' || this.globalModalParams.details[d].code == '000000000000751224' || this.globalModalParams.details[d].code == '751224' || this.globalModalParams.details[d].code == '000000000000751225' || this.globalModalParams.details[d].code == '751225' ) ) {

              if( this.globalModalParams.details[d].hire_period != '0' && this.globalModalParams.details[d].hire_period != '' ) {
                //total = total * item.hire_period;

              if( this.globalModalParams.details[d].price_ex == 0 || this.globalModalParams.details[d].price_ex == '0' ) {
                //totals[this.globalModalParams.details[d].name] = 0;
                fullTotals = fullTotals + 0;
              } else {
                totals[this.globalModalParams.details[d].name] = totals[this.globalModalParams.details[d].name] + ( ( this.globalModalParams.details[d].quantity * this.globalModalParams.details[d].price ) * this.globalModalParams.details[d].hire_period );
                fullTotals = fullTotals + ( ( this.globalModalParams.details[d].quantity * this.globalModalParams.details[d].price ) * this.globalModalParams.details[d].hire_period );
              }

            } else {

              if( this.globalModalParams.details[d].price_ex == 0 || this.globalModalParams.details[d].price_ex == '0' ) {
                //totals[this.globalModalParams.details[d].name] = 0;
                fullTotals = fullTotals + 0;
              } else {
                totals[this.globalModalParams.details[d].name] = totals[this.globalModalParams.details[d].name] + ( this.globalModalParams.details[d].quantity * this.globalModalParams.details[d].price );
                fullTotals = fullTotals + ( this.globalModalParams.details[d].quantity * this.globalModalParams.details[d].price );
              }

            }
          } /*else if( this.globalModalParams.details[d].bw_code == '787515' ) {

              fullTotals = fullTotals + ( this.globalModalParams.details[d].quantity * this.globalModalParams.details[d].price_ex );
              totals['TALISMAN FUEL'] = this.globalModalParams.details[d].quantity * this.globalModalParams.details[d].price_ex;

              var toRemove = ( this.globalModalParams.details[d].quantity * this.globalModalParams.details[d].price_ex );

              vatRemove = toRemove;

            }*/ else {

            if( this.globalModalParams.details[d].bw_code == '787515' || this.globalModalParams.details[d].bw_code == '000000000000787515' ) {

                vatRemove = vatRemove + ( this.globalModalParams.details[d].quantity * this.globalModalParams.details[d].price_ex );

                totals[this.globalModalParams.details[d].name] = vatRemove;
                fullTotals = fullTotals + vatRemove;
              } else {
                if( this.globalModalParams.details[d].price_ex == 0 || this.globalModalParams.details[d].price_ex == '0' ) {
                  //totals[this.globalModalParams.details[d].name] = 0;
                  fullTotals = fullTotals + 0;
                } else {

                  if( this.globalModalParams.details[d].name == 'TALISMAN ACCESSORIES' ) {
                    //totals[this.globalModalParams.details[d].name_sub.trim()] = totals[this.globalModalParams.details[d].name_sub.trim()] + ( this.globalModalParams.details[d].quantity * this.globalModalParams.details[d].price );
                    if (totals[this.globalModalParams.details[d].name_sub.trim()] ) {
                      totals[this.globalModalParams.details[d].name_sub.trim()] = totals[this.globalModalParams.details[d].name_sub.trim()] + ( this.globalModalParams.details[d].quantity * this.globalModalParams.details[d].price );
                    } else {
                      totals[this.globalModalParams.details[d].name_sub.trim()] = ( this.globalModalParams.details[d].quantity * this.globalModalParams.details[d].price );
                    }

                  } else {
                    totals[this.globalModalParams.details[d].name] = totals[this.globalModalParams.details[d].name] + ( this.globalModalParams.details[d].quantity * this.globalModalParams.details[d].price );
                  }

                  fullTotals = fullTotals + ( this.globalModalParams.details[d].quantity * this.globalModalParams.details[d].price );
                }
              }

          }

        }

      }

      var fullTotalsRemoved = fullTotals - vatRemove;

        var totalTax = ( fullTotalsRemoved / 115 ) * 15;

        var toReturn = '';
        var totalDisplay = 0;

        //if( fullTotals != 0 ) {
        toReturn += '<table class="quoteSummaryTable" style="float: right; margin-right: 24px; padding-right: 45px;">';
        for( var t in totals ) {
          if( t != '' && totals[t] != '0' ) {
            totalDisplay = totalDisplay + totals[t];
            toReturn += '<tr>';
            toReturn += '<td width="92%" style="font-size:12px;padding: 8px;text-align:right;">'+t+'</td>';
            toReturn += '<td width="8%" style="font-size:12px;padding: 8px;padding-right:16px;text-align:right">R'+parseFloat(totals[t]).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")+'</td>';
            //toReturn += '<td width="8%" style="font-size:12px;padding: 8px;padding-right:16px;text-align:right">R'+totals[t].toFixed(2)+'</td>';
            toReturn += '</tr>';
          }
        }
        fullTotals = this.fncFormatNumber( fullTotals );
        totalTax = this.fncFormatNumber( totalTax );
        totalDisplay = this.fncFormatNumber( totalDisplay );

        toReturn += '<tr>';
        toReturn += '<td width="92%" style="font-size:14px;padding: 5px 0 !important;text-align:right;"><b>Total</b> <small>( inc VAT )</small></td>';
        toReturn += '<td width="8%" style="font-size:14px;padding: 5px 12px !important;padding-right:16px;font-weight: bold;text-align:right;border-top: 1px solid #333 !important; border-bottom: double 4px #333 !important">'+totalDisplay+'</td>';
        toReturn += '</tr>';
        toReturn += '<tr>';
        toReturn += '<td colspan="2" width="100%" style="font-size:12px;padding: 5px;padding-right:16px;text-align:right;"><small style="display: block; float:right;clear:both;">VAT @ 15% '+totalTax+'</small></td>';
        toReturn += '</tr>';
        toReturn += '</table>';
        //}

      return toReturn;
    },
    fncCheckChildRow( item ) {

      var lineItemData = JSON.parse( item.line_item_data );

      if( ( item.bw_code == '751223' || item.bw_code == '000000000000751223' || item.bw_code == '751224' || item.bw_code == '000000000000751224' || item.bw_code == '751225' || item.bw_code == '000000000000751225' ) && lineItemData.parent_prop != 'undefined' && lineItemData.parent_prop != undefined && lineItemData.parent_prop == '' ) {
        if( ( item.bw_code == '751225' || item.bw_code == '000000000000751225' ) && lineItemData.delivery != undefined ) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }

    },
    fncCheckHireDays( index, type ) {

      var startDate = new Date(this.globalModalParams.details[index].hire_date_start);
      var endDate = new Date(this.globalModalParams.details[index].hire_date_end);

      if( endDate < startDate ) {
        this.globalModalParams.details[index].hire_date_end = this.globalModalParams.details[index].hire_date_start;
        endDate = new Date(this.globalModalParams.details[index].hire_date_end);
      }

      var startDay = startDate.getDate();
      var endDay = endDate.getDate();

      if( startDate.getDate() < 10 ) { startDay = '0'+startDate.getDate(); }
      if( endDate.getDate() < 10 ) { endDay = '0'+endDate.getDate(); }

      var newStartDate = startDate.getFullYear()  + "-" + (startDate.getMonth()+1) + "-" + startDay;
      var newEndDate = endDate.getFullYear()  + "-" + (endDate.getMonth()+1) + "-" + endDay;

      this.globalModalParams.details[index].hire_date_start = newStartDate;
      this.globalModalParams.details[index].hire_date_end = newEndDate;

      var dateDifference = endDate.getTime() - startDate.getTime();
      var days = Math.ceil(dateDifference / (1000 * 3600 * 24));

      this.globalModalParams.details[index].hire_period = days + 1;

    },
    fncHirePeriodMax(index) {

      if( this.globalModalParams.details[index].hire_date_start == this.globalModalParams.details[index].hire_date_end ) {
        return '2';
      } else {
        var startDate = new Date(this.globalModalParams.details[index].hire_date_start);
        var endDate = new Date(this.globalModalParams.details[index].hire_date_end);

        var dateDifference = endDate.getTime() - startDate.getTime();
        var days = Math.ceil(dateDifference / (1000 * 3600 * 24));

        days = days + 1;

        return days;
      }

      return '3';
    },
    fncHirePeriodMin(index) {

      if( this.globalModalParams.details[index].hire_date_start == this.globalModalParams.details[index].hire_date_end ) {
        return '0.5';
      } else {
        var startDate = new Date(this.globalModalParams.details[index].hire_date_start);
        var endDate = new Date(this.globalModalParams.details[index].hire_date_end);

        var dateDifference = endDate.getTime() - startDate.getTime();
        var days = Math.ceil(dateDifference / (1000 * 3600 * 24));

        days = days - 1;

        return days;
      }
    },
    fncSaveLocation() {

      this.globalModalParams.details[this.locationAddIndex].location = this.newLocationName;
      this.globalModalParams.details[this.locationAddIndex].location_drop = this.newLocationName;

      this.locationAddIndex = 0;
      this.newLocationName = '';
      this.showLocationAdd = false;

    },
    fncHasInstall( isInstall ) {

      var addedArticles = [];
      var checkArticles = [];
      var zeroPad = (num, places) => String(num).padStart(places, '0');

      for( var d in this.globalModalParams.details ) {
        if( this.globalModalParams.details[d].deleted == false ) {
          addedArticles[zeroPad(this.globalModalParams.details[d].code,18)] = zeroPad(this.globalModalParams.details[d].code,18);
          addedArticles[this.globalModalParams.details[d].code] = this.globalModalParams.details[d].code;
          addedArticles[parseInt(this.globalModalParams.details[d].code)] = parseInt(this.globalModalParams.details[d].code);
        }
      }

      var installations = this.objAuthorize.installations != undefined ? JSON.parse( this.objAuthorize.installations ) : [];
      var manualInstallations = this.objAuthorize.manual_installations != undefined ? JSON.parse( this.objAuthorize.manual_installations ) : [];
      var objInstallations = [];
      for( var i in installations ) {
        objInstallations.push(installations[i].code);
      }
      for( var i in manualInstallations ) {
        objInstallations.push(manualInstallations[i].code);
      }

      for( var p in this.finalPlistItems ) {
        if( objInstallations.indexOf( this.finalPlistItems[p].article_number ) != -1 && addedArticles[this.finalPlistItems[p].article_number] == undefined ) {
          checkArticles.push(this.finalPlistItems[p]);
        }
      }

        if( checkArticles.length == 0 ) {
          return true;
          // return false;
        }
        return true;

    },
    fncSetClass(index) {
      return 'location_' + index;
    },
    fncCheckLocationDropdown( item ) {

      // props.item.location_drop == 'Create New Location'

    },
    fncSetLocation( index, item ){

      var currentQuantity = this.globalModalParams.details[index].quantity;

      if( this.globalModalParams.details[index].location_drop == 'Create New Location' ) {
        this.showLocationAdd = true;
        this.locationAddIndex = index;
        this.globalModalParams.details[index].location = '';

        var oldThis = this;

        setTimeout(function(){
          oldThis.$refs['location_'+index].focus();
        }, 250)

      } else {
        this.globalModalParams.details[index].location = this.globalModalParams.details[index].location_drop;
      }

      this.globalModalParams.details[index].quantity = 0;
      this.globalModalParams.details[index].quantity = currentQuantity;
    },
    fncGetLocationsLength() {
      var locations =[];
      for( var d in this.globalModalParams.details ) {
        if( this.globalModalParams.details[d].location != undefined && this.globalModalParams.details[d].location != '' ) {
          locations.push({name: this.globalModalParams.details[d].location});
        }
      }
      if( locations.length > 0 ) {
        return true;
      }
      return false;
    },
    fncGetLocations() {

      var locations = [{name: 'Create New Location'}];
      for( var d in this.globalModalParams.details ) {
        if( this.globalModalParams.details[d].location != undefined && this.globalModalParams.details[d].location != '' ) {
          locations.push({name: this.globalModalParams.details[d].location});
        }
      }

      return locations;

    },
    fncPreviewPdf() {

      var deleteCount = 0;

      for( var g in this.globalModalParams.details ) {
        if( this.globalModalParams.details[g].name_sub && this.globalModalParams.details[g].name_sub != '' ) {
          this.globalModalParams.details[g].name = this.globalModalParams.details[g].name + ': ' + this.globalModalParams.details[g].name_sub.trim();
        }
      }

      for( var g in this.globalModalParams.details ) {
        if( this.globalModalParams.details[g].deleted == true ) {
          deleteCount++;
        }
      }

      if( this.globalModalParams.details.length == deleteCount ) {
        this.fncAddRow();
      }

      var address = [];

      if( this.isTallisman == true ) {
        address['addressOne'] = this.addressOne;
        address['addressTwo'] = this.addressTwo;
        address['town'] = this.town;
        address['province'] = this.province;
        address['postalCode'] = this.postalCode;
      }

      this.$store.commit('fncSetEditLoading', false);
      this.$store.dispatch({
        type: 'fncSaveQuoteItems',
        data: this.globalModalParams.details,
        id: this.globalModalParams.id,
        vendorId: this.globalModalParams.vendorId,
        sendHybris: false,
        doPdf: true,
        notes: this.notes + '||' + this.customerAccountType + '||' + this.customerAccountNumber,
        address: address,
        tallisman: this.isTallisman
      })

      for( var g in this.globalModalParams.details ) {
        if( this.globalModalParams.details[g].name_sub && this.globalModalParams.details[g].name_sub != '' ) {
          var split = this.globalModalParams.details[g].name.split(':');
          this.globalModalParams.details[g].name = split[0];
        }
      }

      //this.$store.dispatch('fncGeneratePdf', this.globalModalParams.id );
    },
    fncGetCalcName( calculator ) {
      for( var r in this.departmentRangesListFiltered ) {
        if( this.departmentRangesListFiltered[r].id32 == calculator ) {
          return this.departmentRangesListFiltered[r].name
        }
      }

      return 'N/A';
    },
    fncIsCalcDisabled( item ) {

      if( item.m2m == false ) {
        if( item.edit_current == undefined || item.edit_current == false) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    fncGetCalcCost( index, item ){
      if( item.m2m == false && item.cost_price == '0'  ) {
        return '<span style="padding-top: 9px;display: inline-block;">N/A</span>';
      }
      //return '<span style="padding-top: 9px;display: inline-block;">R&nbsp;' + item.cost_price + '</span>';
      return '<span style="padding-top: 9px;display: inline-block;">R&nbsp;' + parseFloat(item.cost_price).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + '</span>';
    },
    fncGetCalcMargin(index, item){
      if( item.m2m == false && item.cost_price == '0'  ) {
        return '<span style="padding-top: 9px;display: inline-block;">N/A</span>';
      }
      return '<span style="padding-top: 9px;display: inline-block;">' + item.markup + '&nbsp;%</span>';
    },
    fncClearCalculator(index) {
      this.globalModalParams.details[index].calculator = undefined;
    },
    fncNotMtm( item ) {

      if( item.show_calculator == undefined ) {
        return true;
      } else if( item.show_calculator != undefined && item.show_calculator == true ) {
        return true;
      } else if( item.m2m != undefined && item.m2m == true ) {
        return false;
      }
      return true;
    },
    fncGetTotalVat() {

      var total = 0;

      for( var i in this.globalModalParams.details ) {

        if( this.globalModalParams.details[i].deleted != true ) {
          var item = this.globalModalParams.details[i];

          var lineItemData = JSON.parse( item.line_item_data );

          if( lineItemData.ex_price != undefined ) {

            var cost = lineItemData.ex_price;
            //cost = cost * 1.15;

          } else {

            var cost = item.price;

          }

          cost = cost * item.quantity;

          total = total + cost;
        }

      }

      total = ( total / 1.15 );
      total = ( total / 100 ) * 15;

      return 'VAT @ 15% R' + parseFloat(total).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"); ;

    },
    fncGetFinalTotal(){

      var total = 0;

      for( var i in this.globalModalParams.details ) {

        if( this.globalModalParams.details[i].deleted != true ) {
          var item = this.globalModalParams.details[i];

          var lineItemData = JSON.parse( item.line_item_data );

          if( lineItemData.ex_price != undefined ) {

            var cost = lineItemData.ex_price;
            cost = cost * 1.15;

          } else {

            var cost = item.price;

          }

          cost = cost * item.quantity;

          total = total + cost;
        }

      }

      return 'R' + parseFloat(total).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");

    },
    fncFormatUom( item ) {

      if( item.uom ) {
        var uom = item.uom;
        uom = uom.replace(item.quantity+'x', '')
        uom = uom.replace(item.quantity+'X', '')

        return uom;
      }

      return 'Ea';

    },
    fncFormatNumber( value, productCode = '' ) {

      if( productCode != '' && ( productCode == '787515' || productCode == '000000000000787515' ) ) {
        return 'R0.00';
      }
      // return 'R' + parseFloat(value).toFixed(2);
      return 'R' + parseFloat(value).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");

    },
    fncIsDisabledMargin( item ) {

      if( item.is_install == true && this.loadedDepartment.can_update_installation_margin == '0' ) {
        return true;
      } else if( item.is_install == false && this.loadedDepartment.can_update_sales_margin == '0' ) {
        return true;
      }

      var zeroPad = (num, places) => String(num).padStart(places, '0');

      if( this.loadedDepartment.article_margins != '' && this.loadedDepartment.article_margins != 'null' && this.loadedDepartment.article_margins != null ) {

        var hasCheck = false;

        var articleMargins = JSON.parse( this.loadedDepartment.article_margins );

        for( var m in articleMargins ) {

          var bwArticle = zeroPad( articleMargins[m].article, 18 );

          if( bwArticle == item.code || articleMargins[m].article == item.code ) {

            /*console.log( bwArticle );
            console.log( articleMargins[m] );*/

            if( articleMargins[m].override != undefined ) {
              if( articleMargins[m].override == 'true' || articleMargins[m].override == true ) {
                return false;
              } else {
                return true;
              }
            } else {
              if( item.is_install == true && this.loadedDepartment.can_update_installation_margin == '0' ) {
                return true;
              } else if( item.is_install == false && this.loadedDepartment.can_update_sales_margin == '0' ) {
                return true;
              }
            }

          }

        }

      } else {
        if( item.is_install == true && this.loadedDepartment.can_update_installation_margin == '0' ) {
          return true;
        } else if( item.is_install == false && this.loadedDepartment.can_update_sales_margin == '0' ) {
          return true;
        }
      }

      return false;

    },
    fncIsDisabled( item ) {

      if( item.is_install == true && this.loadedDepartment.can_update_installation_margin == '0' ) {
        return true;
      } else if( item.is_install == false && this.loadedDepartment.can_update_sales_margin == '0' ) {
        return true;
      }

      return false;

    },
    fncIsDisabledCost( item ) {

      if( item.is_install == true && this.loadedDepartment.can_update_cost_price_installation == '0' ) {
        return true;
      } else if( item.is_install == false && this.loadedDepartment.can_update_cost_price == '0' ) {
        return true;
      }

      var zeroPad = (num, places) => String(num).padStart(places, '0');

      if( this.loadedDepartment.article_margins != '' && this.loadedDepartment.article_margins != 'null' && this.loadedDepartment.article_margins != null ) {

        var hasCheck = false;

        var articleMargins = JSON.parse( this.loadedDepartment.article_margins );

        for( var m in articleMargins ) {

          var bwArticle = zeroPad( articleMargins[m].article, 18 );

          if( bwArticle == item.code ) {

            if( articleMargins[m].override_cost != undefined ) {
              if( articleMargins[m].override_cost == 'true' || articleMargins[m].override_cost == true ) {
                return false;
              } else {
                return true;
              }
            } else {
              if( item.is_install == true && this.loadedDepartment.can_update_cost_price_installation == '0' ) {
                return true;
              } else if( item.is_install == false && this.loadedDepartment.can_update_cost_price == '0' ) {
                return true;
              }
            }

          }

        }

      } else {
        if( item.is_install == true && this.loadedDepartment.can_update_cost_price_installation == '0' ) {
          return true;
        } else if( item.is_install == false && this.loadedDepartment.can_update_cost_price == '0' ) {
          return true;
        }
      }

      return false;

      /*if( item.is_install == true && this.loadedDepartment.can_update_cost_price_installation == '0' ) {
        return true;
      } else if( item.is_install == false && this.loadedDepartment.can_update_cost_price == '0' ) {
        return true;
      }

      return false;*/

    },
    fncGetTotal( item, productCode = '' ) {
      /*if( item.set_price != undefined ) {
        return item.set_price;
      } else {*/
      if( productCode != '' && ( productCode == '787515' || productCode == '000000000000787515' ) ) {

        var cost = item.price_ex;

        cost = cost * item.quantity;

        return 'R' + parseFloat(cost).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      } else {
        var lineItemData = JSON.parse(item.line_item_data);

        if (lineItemData.ex_price != undefined) {

          var cost = lineItemData.ex_price;
          cost = cost * 1.15;

        } else {

          var cost = item.price;

        }

        cost = cost * item.quantity;

        if (this.isTallisman == true && item.hire_period && item.hire_period != '' && item.hire_period != 'NaN') {
          cost = cost * item.hire_period;
        }

        return 'R' + parseFloat(cost).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      }
      //}

      // return 'R' + parseInt( cost ).toFixed(2);
    },
    fncGetUnitTotal( item, productCode = '' ) {

      if( productCode != '' && ( productCode == '787515' || productCode == '000000000000787515' ) ) {
        return 'R' + parseFloat(item.price_ex).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      } else if( item.set_price != undefined ) {
        return 'R' + parseFloat(item.set_price).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        //return item.set_price;
      } else {
        var lineItemData = JSON.parse(item.line_item_data);

        if (lineItemData.ex_price != undefined) {

          var cost = lineItemData.ex_price;
          cost = cost * 1.15;

          return 'R' + parseFloat(cost).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");

        } else {

          return 'R' + parseFloat(item.price).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");

        }
      }

    },
    fncInputQty( item ) {
      var lineItemData = JSON.parse( item.line_item_data );

      /*if( lineItemData.can_edit_ex != undefined ) {
        return true;
      } else {
        return false;
      }*/

      if( item.m2m == true || ( lineItemData.m2m != undefined && lineItemData.m2m == true ) || ( item.edit_current != undefined && item.edit_current == true ) ) {
        return true;
      }
      return false;
    },
    fncInputEx( item ) {

      var lineItemData = JSON.parse( item.line_item_data );

      if( item.m2m == true || ( lineItemData.m2m != undefined && lineItemData.m2m == true ) ) {
        return true;
      }
      return false;

    },
    fncFilterIndexItems( index, rangeId ) {

      if( rangeId == 'm2m' ) {
        this.globalModalParams.details[index].m2m = true;
      } else {
        this.globalModalParams.details[index].m2m = false;
      }

      this.$store.commit( 'setSpineLoading', true );

      this.globalModalParams.details[index].name = '';
      this.globalModalParams.details[index].name_sub = 'Default';

      this.globalModalParams.details[index].price_ex = 0;
      this.globalModalParams.details[index].quantity = 1;
      this.globalModalParams.details[index].edit_current = true;
      this.globalModalParams.details[index].bw_code = 0;
      this.globalModalParams.details[index].vat = 0;
      if( this.globalModalParams.details[index].is_install == true && this.loadedDepartment.department_installation_margin != '' && this.loadedDepartment.department_installation_margin != '0' ) {
        this.globalModalParams.details[index].markup = this.loadedDepartment.department_installation_margin;
      } else if( this.loadedDepartment.department_margin != '' && this.loadedDepartment.department_margin != '0' ) {
        this.globalModalParams.details[index].markup = this.loadedDepartment.department_margin;
      }

      for( var r in this.rangeFilters ) {
        if( this.rangeFilters[r].range == rangeId ) {
          this.globalModalParams.details[index].filter = this.rangeFilters[r].filter;
          this.globalModalParams.details[index].setFilter = this.rangeFilters[r].filter;
        }
      }

      if( rangeId == 'm2m' ) {
        var oldThis = this;
        setTimeout(function(){
          oldThis.$store.commit( 'setSpineLoading', false );
        }, 250)
      } else {

        var hasItems = false;
        for( var c in this.calculatorFilters ) {
          if( this.calculatorFilters[c].rangeId == rangeId ) {
            hasItems = true;
          }
        }

        if( hasItems == true ) {
          this.$store.commit({
            type: 'fncSetDisabled',
            rangeId: rangeId,
            addedItems: this.globalModalParams.details

          });
          var oldThis = this;
          setTimeout(function(){
            oldThis.$store.commit( 'setSpineLoading', false );
          }, 250)

        } else {
          this.$store.dispatch({
            type: 'getStoreItems',
            store: this.globalModalParams.storeName,
            customer: this.globalModalParams.customer,
            range: rangeId,
            addedItems: this.globalModalParams.details
          })
        }

        /*var hasItems = false;
        for (var c in this.calculatorFilters) {
          if ( this.calculatorFilters[c].rangeId == rangeId ) {
            hasItems = true;
          }
        }
        if( hasItems == true ) {
          var oldThis = this;
          setTimeout(function(){
            oldThis.$store.commit( 'setSpineLoading', false );
          }, 250)
        } else {
          this.$store.dispatch({
            type: 'getStoreItems',
            store: this.globalModalParams.storeName,
            customer: this.globalModalParams.customer,
            range: rangeId
          })
        }*/

      }


      /*if( this.globalModalParams.details[index].calculator == 'm2m' ) {
        this.globalModalParams.details[index].price_ex = 0;
        this.globalModalParams.details[index].quantity = 1;
        this.globalModalParams.details[index].vat = 0;
        if( this.globalModalParams.details[index].is_install == true && this.loadedDepartment.department_installation_margin != '' && this.loadedDepartment.department_installation_margin != '0' ) {
          this.globalModalParams.details[index].markup = this.loadedDepartment.department_installation_margin;
        } else if( this.loadedDepartment.department_margin != '' && this.loadedDepartment.department_margin != '0' ) {
          this.globalModalParams.details[index].markup = this.loadedDepartment.department_margin;
        }
      } else {
        this.globalModalParams.details[index].price_ex = 0;
        this.globalModalParams.details[index].quantity = 1;
        this.globalModalParams.details[index].vat = 0;
        // this.globalModalParams.details[index].show_calculator = true
      }*/
      //this.$store.dispatch('fncFilterLineItems', rangeId);

      /*var newItems = [];

      for( var i in this.globalModalParams.details[index].finalPlistItems ) {
        if( this.loadedDepartment.ranges.indexOf( this.globalModalParams.details[index].finalPlistItems[i].range_id ) != -1 ) {
          newItems.push( this.globalModalParams.details[index].finalPlistItems[i] );
        }
      }

      this.globalModalParams.details[index].finalPlistItems = newItems;*/

      //this.$store.dispatch('fncGetItems', rangeId);

    },
    fncShowRow( key ) {

      for( var h in this.headers ) {
        if(this.headers[h].value == key) {
          return true;
        }
      }
      return false;
    },
    fncCheckMeasure( m2m ) {
      if( m2m == undefined || m2m == false ) {
        return false;
      }
      return true;
    },
    fncNotInstall( code ) {

      var installations = this.fncFinalItems( true );
      if( installations.length > 0 ) {
        for( var i in installations ) {
          if( installations[i].article_number == code ) {
            return false;
          }
        }
      }
      return true;

    },
    fncShowMarkup( markup ) {
      /*if( markup == '0' || markup == '' || markup == undefined || markup == 'undefined' ) {
        return 'N/A';
      } else {
        return markup;
      }*/
      if( markup == '0' || markup == '' || markup == undefined || markup == 'undefined' || markup == '0.00 %' ) {
        return 0;
      } else {
        return markup;
      }
    },
    fncNotInstall(obj) {
      if( obj.is_install == undefined || obj.is_install == false ) {
        return true;
      } else {
        return false;
      }
    },
    fncGetClass( obj ) {
      if( obj.is_install == undefined || obj.is_install == false ) {
        return 'noninstallation';
      } else {
        return 'installation';
      }
    },
    fncCheckDisabled( key ) {

      /*if( this.globalModalParams.details[index].m2m != undefined && this.globalModalParams.details[index].m2m == false ) {
        return false;
      }*/

      if( key == '' || key == '0' || key == 'undefined' || key == undefined ) {
        return false;
      }

      return true;

    },
    fncCheckDisabledCost( key ) {

      if( key == '' || key == '0' || key == 'undefined' || key == undefined ) {
        return false;
      }

      return true;

    },
    fncCanInstall( index ) {

      /*for( var d in this.departmentList ) {
        if( this.departmentList[d].id == this.globalModalParams.departmentId ) {
          if( this.departmentList[d].installation_articles != null && this.departmentList[d].installation_articles != '' ) {
            return false;
          }
        }
      }*/

        var newIndex = index + 1;

        if( this.globalModalParams.details[newIndex] && this.globalModalParams.details[newIndex].is_install != undefined && this.globalModalParams.details[newIndex].is_install == true ) {
          if( this.globalModalParams.details[newIndex].deleted == true ) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }

        // return true;

    },
    fncFinalItemsFiltered( isInstall, calculator, tallisman = false, setFilters = '', index ) {

      var zeroPad = (num, places) => String(num).padStart(places, '0');

      var installations = this.objAuthorize.installations != undefined ? JSON.parse( this.objAuthorize.installations ) : [];
      var manualInstallations = this.objAuthorize.manual_installations != undefined ? JSON.parse( this.objAuthorize.manual_installations ) : [];
      var objInstallations = [];
      for( var i in installations ) {
        objInstallations.push(installations[i].code);
      }
      for( var i in manualInstallations ) {
        objInstallations.push(manualInstallations[i].code);
      }
      var displayDropdown = [];

      if( isInstall == undefined || isInstall == 'undefined' || isInstall == false ) {
        for( var p in this.finalPlistItems ) {
          //for( var p in this.finalPlistItems ) {
          //if( objInstallations.indexOf( this.finalPlistItems[p].article_number ) == -1 ) {
          if( tallisman == true ) {
            if( this.finalPlistItems[p].article_number != '000000000000751226' && this.finalPlistItems[p].article_number != '751226' && this.finalPlistItems[p].article_number != '000000000000751229' && this.finalPlistItems[p].article_number != '751229' ) {
              displayDropdown.push(this.finalPlistItems[p]);
            }
          } else {
            displayDropdown.push(this.finalPlistItems[p]);
          }

          //}
        }
      } else {
        for( var p in this.finalPlistItems ) {
          if( objInstallations.indexOf( this.finalPlistItems[p].article_number ) != -1 ) {
            displayDropdown.push(this.finalPlistItems[p]);
          }
        }
      }

      console.log('Calc');
      console.log( calculator );

      if( calculator != undefined && calculator != '' && calculator != 'm2m' ) {

        if (this.calculatorFilters.length > 0) {

          var calculatorItems = [];
          var itemRefs = [];
          for (var c in this.calculatorFilters) {


            if ( this.calculatorFilters[c].rangeId == calculator ) {

              console.log('Filter');
              console.log( this.globalModalParams.details[index].filter );

              for( var i in this.calculatorFilters[c].items ) {

                if( this.globalModalParams.details[index].filter == '' || this.globalModalParams.details[index].filter == 'all' ) {
                  //if( this.calculatorFilters[c].items[i].spine_listed && this.calculatorFilters[c].items[i].spine_listed == true ) {
                  var bwArticle = zeroPad( this.calculatorFilters[c].items[i].article, 18 );
                  this.itemRefs[bwArticle] = this.calculatorFilters[c].items[i].image;
                  itemRefs[bwArticle] = this.calculatorFilters[c].items[i].image;
                  calculatorItems.push(this.calculatorFilters[c].items[i]);
                  //}
                } else {
                  if( this.calculatorFilters[c].items[i].filter == this.globalModalParams.details[index].filter ) {
                    //if( this.calculatorFilters[c].items[i].spine_listed && this.calculatorFilters[c].items[i].spine_listed == true ) {
                    var bwArticle = zeroPad( this.calculatorFilters[c].items[i].article, 18 );
                    this.itemRefs[bwArticle] = this.calculatorFilters[c].items[i].image;
                    itemRefs[bwArticle] = this.calculatorFilters[c].items[i].image;
                    calculatorItems.push(this.calculatorFilters[c].items[i]);
                    //}
                  }
                }

              }

              /*for( var d in displayDropdown ) {
                //if( this.itemRefs[displayDropdown[d].article_number] != undefined ) {
                //if( itemRefs[displayDropdown[d].article_number] != undefined ) {
                  calculatorItems.push(displayDropdown[d]);
                //}
              }*/

              return calculatorItems;

            }
          }
        }
      }

      return displayDropdown;

    },
    fncFinalItemsFilteredFilter( isInstall, calculator, tallisman = false ) {

      if( calculator != undefined && calculator != '' && calculator != 'm2m' ) {

        var filters = [{ id: '', name: 'All' }];

        if (this.calculatorFilters.length > 0) {

          var itemRefs = [];
          for (var c in this.calculatorFilters) {
            if ( this.calculatorFilters[c].rangeId == calculator ) {

              for( var i in this.calculatorFilters[c].items ) {

                if( this.calculatorFilters[c].items[i].filter && this.calculatorFilters[c].items[i].filter != undefined ) {
                  var name = this.calculatorFilters[c].items[i].filter.replace('code_','');
                  name = name[0].toUpperCase() + name.slice(1);

                  filters.push({ id: this.calculatorFilters[c].items[i].filter, name: name });
                }
                //if( this.calculatorFilters[c].items[i].spine_listed && this.calculatorFilters[c].items[i].spine_listed == true ) {
                /*var bwArticle = zeroPad( this.calculatorFilters[c].items[i].article, 18 );
                this.itemRefs[bwArticle] = this.calculatorFilters[c].items[i].image;
                itemRefs[bwArticle] = this.calculatorFilters[c].items[i].image;
                calculatorItems.push(this.calculatorFilters[c].items[i]);*/
                //}
              }

            }
          }

          return filters;
        }
      } else {
        var filters = [{ id: '', name: 'All' }];

        return filters;
      }

      return [];

    },
    fncFinalItems( isInstall ) {

      /*var hasDepartmentInstallation = false;

      for( var d in this.departmentList ) {
        if( this.departmentList[d].id == this.globalModalParams.departmentId ) {
          if( this.departmentList[d].installation_articles != null && this.departmentList[d].installation_articles != '' ) {
            hasDepartmentInstallation =  true;
          }
        }
      }

      if( hasDepartmentInstallation == true ) {
        var displayDropdown = [];

        for( var p in this.finalPlistItems ) {
          displayDropdown.push(this.finalPlistItems[p]);
        }
      } else {*/
      var installations = this.objAuthorize.installations != undefined ? JSON.parse( this.objAuthorize.installations ) : [];
      var manualInstallations = this.objAuthorize.manual_installations != undefined ? JSON.parse( this.objAuthorize.manual_installations ) : [];
      var objInstallations = [];
      for( var i in installations ) {
        objInstallations.push(installations[i].code);
      }
      for( var i in manualInstallations ) {
        objInstallations.push(manualInstallations[i].code);
      }
      var displayDropdown = [];

      if( isInstall == undefined || isInstall == 'undefined' || isInstall == false ) {
        for( var p in this.finalPlistItems ) {
          //for( var p in this.finalPlistItems ) {
          //if( objInstallations.indexOf( this.finalPlistItems[p].article_number ) == -1 ) {
          displayDropdown.push(this.finalPlistItems[p]);
          //}
        }
      } else {
        for( var p in this.finalPlistItems ) {
          if( objInstallations.indexOf( this.finalPlistItems[p].article_number ) != -1 ) {
            displayDropdown.push(this.finalPlistItems[p]);
          }
        }
      }
      // }

      return displayDropdown;
    },
    fncAddInstallation( index ) {

      //this.installed = true;
      var newOrderItems = [];

        for( var n in this.globalModalParams.details ) {
          if( n == index ) {
            newOrderItems.push( this.globalModalParams.details[n] );
            //this.isDisabled = 'false';
            var storeId = '';
            var location = '';
            for( var p in this.globalModalParams.details ) {
              var lineItemData = JSON.parse(this.globalModalParams.details[p].line_item_data);
              if( lineItemData.store_id != undefined && lineItemData.store_id != null && lineItemData.store_id != 'null' ) {
                storeId = lineItemData.store_id;
              }
            }
            if( this.globalModalParams.details[n].location != undefined && this.globalModalParams.details[n].location != 'null' ) {
              location = this.globalModalParams.details[n].location;
            }
            if( storeId == '' ) {
              storeId = this.globalModalParams.storeName;
            }
            var lineItemData = JSON.stringify({ 'added_from_screen' : true, 'm2m': true, 'location': location, 'can_edit_ex': true, 'store_id': storeId, 'type': 'set', 'is_install': true });
            var markup = '0';
            if( this.loadedDepartment.department_installation_margin != '' && this.loadedDepartment.department_installation_margin != '0' ) {
              markup = this.loadedDepartment.department_installation_margin;
            }
            newOrderItems.push({ calculator: 'm2m', is_install: true, location: location, m2m: true, markup: markup, p_key: '0', is_install: true, bw_code: 0, type: 'set', id: '', name: '', quantity: '1', price: '0',cost_price: '0',price_ex: '0',vat: 0,code: '', range_id: '', deleted: false, line_item_data: lineItemData });
          } else {
            newOrderItems.push( this.globalModalParams.details[n] );
          }
        }

      this.globalModalParams.details = newOrderItems;

      this.fncCanSave();

      /*this.isDisabled = 'true';
      var storeId = '';
      for( var p in this.globalModalParams.details ) {
        var lineItemData = JSON.parse(this.globalModalParams.details[p].line_item_data);
        if( lineItemData.store_id != undefined && lineItemData.store_id != null && lineItemData.store_id != 'null' ) {
          storeId = lineItemData.store_id;
        }
      }
      if( storeId == '' ) {
        storeId = this.globalModalParams.storeName;
      }
      var lineItemData = JSON.stringify({ 'store_id': storeId, 'type': 'set' });
      this.globalModalParams.details.push({ is_install: true, bw_code: 0, type: 'set', id: '', name: '', quantity: '1', price: '0',cost_price: '0',price_ex: '0',vat: 0,code: '', range_id: '', deleted: false, line_item_data: lineItemData });*/
      //this.globalModalParams.details.push({ id: '', name: '', quantity: '1', price: '0',cost_price: '0',code: '', range_id: '', deleted: false, line_item_data: lineItemData });

    },
    fncSendToHybrisTrolley() {

      var statusName = '';
      if( this.statusList.length > 0 ) {
        for( var s in this.statusList ) {
          if( this.statusList[s].is_hybris_trolley == 'Yes' ) {
            statusName = this.statusList[s].description;
          }
        }
      }

      if( statusName != '' ) {

        this.isLoading = true;

        var deleteCount = 0;

        for( var g in this.globalModalParams.details ) {
          if( this.globalModalParams.details[g].price_ex == '0' || this.globalModalParams.details[g].price_ex == '0.00' ) {
            this.globalModalParams.details[g].deleted = true;
          }
          if( this.globalModalParams.details[g].bw_code == '' || this.globalModalParams.details[g].bw_code == '0' ) {
            this.globalModalParams.details[g].name = this.globalModalParams.details[g].name_sub;
          } else {
            if( this.globalModalParams.details[g].name_sub && this.globalModalParams.details[g].name_sub != '' ) {
              this.globalModalParams.details[g].name = this.globalModalParams.details[g].name + ': ' + this.globalModalParams.details[g].name_sub.trim();
            } else {
              this.globalModalParams.details[g].name = this.globalModalParams.details[g].name;
            }
          }
        }

        for( var g in this.globalModalParams.details ) {
          if( this.globalModalParams.details[g].deleted == true ) {
            deleteCount++;
          }
        }

        if( this.globalModalParams.details.length == deleteCount ) {
          this.fncAddRow();
        }

        var address = [];

        if( this.isTallisman == true ) {
          address['addressOne'] = this.addressOne;
          address['addressTwo'] = this.addressTwo;
          address['town'] = this.town;
          address['province'] = this.province;
          address['postalCode'] = this.postalCode;
        }

        this.$store.commit('fncSetEditLoading', false);
        this.$store.dispatch({
          type: 'fncSaveQuoteItems',
          data: this.globalModalParams.details,
          id: this.globalModalParams.id,
          vendorId: this.globalModalParams.vendorId,
          sendHybris: true,
          hybrisData: this.globalModalParams,
          hybrisStatusName: statusName,
          notes: this.notes + '||' + this.customerAccountType + '||' + this.customerAccountNumber,
          address: address,
          tallisman: this.isTallisman
        })

        /*this.$store.dispatch({
          type: 'fncSendToHybrisShoppingList',
          data: this.globalModalParams,
          statusName: statusName
        })*/
      }

    },
    fncSendToHybris() {

      var statusName = '';
      if( this.statusList.length > 0 ) {
        for( var s in this.statusList ) {
          if( this.statusList[s].is_hybris == 'Yes' ) {
            statusName = this.statusList[s].description;
          }
        }
      }

      if( statusName != '' ) {
        this.isLoading = true;
        this.$store.dispatch({
          type: 'fncSendToHybrisShoppingList',
          data: this.globalModalParams,
          statusName: statusName
        })
      }

    },
    fncGetVendor( obj ) {

      var zeroPad = (num, places) => String(num).padStart(places, '0');

      if( obj.bw_code == 0 ) {
        var trailingRemoved = '';
      } else {
        var trailingRemoved = obj.bw_code.replace(/^0+/, '');
        trailingRemoved = zeroPad( trailingRemoved, 18 );
      }

      if( obj.bw_code == '' || obj.bw_code == '0' ) {
        return 'N/A';
      } else {

        var hasVendor = false;

        for( var v in this.vendorListCodes ) {
          if( this.vendorListCodes[v].code == obj.code || this.vendorListCodes[v].code == trailingRemoved ) {
            return this.vendorListCodes[v].vendor;
          }
        }

        var allItems = this.fncFinalItems( false );

        // for( var g in this.globalModalParams.vendorCodes ) {

        for( var v in allItems ) {
          if( allItems[v].article_number == trailingRemoved ) {
            return allItems[v].vendor;
          }
        }

        return 'N/A';
        /*if( this.globalModalParams.vendorCodes[obj.bw_code] != null || this.globalModalParams.vendorCodes[trailingRemoved] != null ) {
         if( this.globalModalParams.vendorCodes[obj.bw_code] != null ) {
           return this.globalModalParams.vendorCodes[obj.bw_code];
         } else {
           return this.globalModalParams.vendorCodes[trailingRemoved];
         }
        } else {
          return 'N/A';
        }*/
        // }
      }
    },
    fncCheckVat( index ) {
      //console.log( this.globalModalParams.details[index] );
    },
    fncShowInitialMarkup( item ) {
      var lineItem = JSON.parse( item.line_item_data );
      //var markUp = ( ( lineItem.cost_price * 100 ) / lineItem.price_ex ) + '%'
      return lineItem.markup.toFixed(2);
    },
    fncRecalculateMarkups() {
      for( var p in this.globalModalParams.details ) {
        //var lineItemData = JSON.parse(this.globalModalParams.details[p].line_item_data);
        if( this.globalModalParams.details[p].m2m != undefined && this.globalModalParams.details[p].m2m == false ) {
          //if( this.globalModalParams.details[p].price_ex != '' && this.globalModalParams.details[p].price_ex != '0' && this.globalModalParams.details[p].cost_price != '' && this.globalModalParams.details[p].cost_price != '0' ) {
          // if( this.globalModalParams.details[p].price != '' && this.globalModalParams.details[p].price != '0' && this.globalModalParams.details[p].cost_price != '' && this.globalModalParams.details[p].cost_price != '0' ) {
          var markUp = ( ( this.globalModalParams.details[p].cost_price * 100 ) / this.globalModalParams.details[p].price_ex );
          // var markUp = ( ( this.globalModalParams.details[p].cost_price * 100 ) / this.globalModalParams.details[p].price )
          markUp = 100 - markUp.toFixed(2);
          markUp = parseFloat(markUp)
          markUp = markUp.toFixed(2);
          this.globalModalParams.details[p].markup = markUp + ' %%%';
          //this.globalModalParams.details[p].markup = markUp + ' %';
          // this.globalModalParams.details[p].markup = markUp.toFixed(markUp, 2);
        } /*else {
            if( this.globalModalParams.details[p].is_install == false && this.departmentMargin != '0' && this.departmentMargin != '' ) {
              this.globalModalParams.details[p].markup = this.departmentMargin;
            } else if( this.globalModalParams.details[p].is_install == true && this.departmentInstallationMargin != '0' && this.departmentInstallationMargin != '' ) {
              this.globalModalParams.details[p].markup = this.departmentInstallationMargin;
            } else {
              this.globalModalParams.details[p].markup = 'N/A'
            }
          }
          if( this.globalModalParams.details[p].markup != '' && this.globalModalParams.details[p].markup != 'N/A' && ( this.globalModalParams.details[p].cost_price == '' || this.globalModalParams.details[p].cost_price == '0' ) ) {
            this.globalModalParams.details[p].cost_price = '1000';

          }*/

      }
    },
    /*fncRecalculateCostPrice() {
      for( var p in this.globalModalParams.details ) {
        if( this.globalModalParams.details[p].price == '' || this.globalModalParams.details[p].price == '0' ) {
          this.globalModalParams.details[p].cost_price = 0;
        } else {
          this.globalModalParams.details[p].updateMargin = false;

          if( this.globalModalParams.details[p].is_install == false && this.departmentMargin != '0' && this.departmentMargin != '' ) {
            this.globalModalParams.details[p].markup = this.departmentMargin;
            var costPrice = this.globalModalParams.details[p].price * ( this.globalModalParams.details[p].markup / 100 );
          } else if( this.globalModalParams.details[p].is_install == true && this.departmentInstallationMargin != '0' && this.departmentInstallationMargin != '' ) {
            this.globalModalParams.details[p].markup = this.departmentInstallationMargin;
            var costPrice = this.globalModalParams.details[p].price * ( this.globalModalParams.details[p].markup / 100 );
          } else {
            this.globalModalParams.details[p].markup = 'N/A'
          }
        }
      }
    },*/
    checkMinus() {
      var mustAlert = false;
      for( var d in this.globalModalParams.details ) {
        var priceEx = String(this.globalModalParams.details[d].price_ex);
        var costPrice = String(this.globalModalParams.details[d].cost_price);

        if( priceEx.indexOf('-') != -1 ) {
          priceEx = priceEx.replace('-', '');
          this.globalModalParams.details[d].price_ex = priceEx;
          //this.globalModalParams.details[d].price_ex = parseFloat( priceEx );
          mustAlert = true;
        }
        if( costPrice.indexOf('-') != -1 ) {
          costPrice = costPrice.replace('-', '');
          this.globalModalParams.details[d].cost_price = costPrice;
          //this.globalModalParams.details[d].cost_price = parseFloat( costPrice );
          mustAlert = true;
        }
        if( priceEx.indexOf(',') != -1 ) {
          priceEx = priceEx.replace(',', '');
          this.globalModalParams.details[d].price_ex = priceEx;
          //this.globalModalParams.details[d].price_ex = parseFloat( priceEx );
          mustAlert = true;
        }
        if( costPrice.indexOf(',') != -1 ) {
          costPrice = costPrice.replace(',', '');
          //this.globalModalParams.details[d].cost_price = parseFloat( costPrice );
          this.globalModalParams.details[d].cost_price = costPrice;
          mustAlert = true;
        }
        if( parseFloat(costPrice) > parseFloat(priceEx) ) {
          //this.globalModalParams.details[d].cost_price = this.globalModalParams.details[d].price_ex;
          mustAlert = true;
        }
      }
      /*if( mustAlert == true ) {
        // alert('Please enter a valid cost price. Your cost price cannot be higher than your selling price.');
        this.isDisabled = 'false';
      } else {
        this.isDisabled = 'true';
      }*/
    },
    fncCanSave(index, type = '') {

      // this.checkMinus();
      if( type != '' && type != 'qty' ) {
        this.fncCalculateValues(index, type);
      }
      // this.fncRecalculateMarkups();
      // this.fncRecalculateCostPrice();
      var isDis = 'true';
      //var isDis = this.isDisabled;
      for( var d in this.globalModalParams.details ) {
        if( this.globalModalParams.details[d].quantity < 1 ) {
          this.globalModalParams.details[d].quantity = 1;
        }

        /*var priceEx = this.globalModalParams.details[d].price_ex.replace(/-/g,'');
        this.globalModalParams.details[d].price_ex = 0;*/

        // if( this.globalModalParams.details[d].cost_price != undefined && this.globalModalParams.details[d].price_ex != undefined ) {
        /*if( this.globalModalParams.details[d].deleted == false && ( this.globalModalParams.details[d].cost_price == '0' || this.globalModalParams.details[d].price_ex == '0' ) ) {
          isDis = 'true';
          console.log('IS FALSE');
        } */ /*else {
              isDis = 'false';
            }*/
        // }

        /*if( ( this.globalModalParams.details[d].m2m != undefined && this.globalModalParams.details[d].m2m != false ) || this.fncCheckDisabledCost(this.globalModalParams.details[d].p_key) ) {
          // do nothing for now
        } else {
          if( this.globalModalParams.details[d].deleted == false && ( this.globalModalParams.details[d].cost_price == '0' || this.globalModalParams.details[d].cost_price == '0.00' || this.globalModalParams.details[d].cost_price == '' ) ) {
            isDis = 'false';
          }
        }*/

        var priceEx = String(this.globalModalParams.details[d].price_ex);
        var costPrice = String(this.globalModalParams.details[d].cost_price);

          if( this.globalModalParams.details[d].deleted == false && priceEx.indexOf('-') != '-1' ) {
            isDis = 'false';
            //console.log('One');
          }

          if( this.globalModalParams.details[d].deleted == false && ( priceEx == '0' || priceEx == '0.00' || priceEx == '' ) ) {
            isDis = 'false';
            //console.log('Two');
          }

          /*if( this.globalModalParams.details[d].deleted == false && this.globalModalParams.details[d].markup != '' && this.globalModalParams.details[d].markup != '0.00' && this.globalModalParams.details[d].markup != '0' && ( costPrice == '0' || costPrice == '0.00' || costPrice == '' ) ) {
            isDis = 'false';
          }*/

        /*if( this.globalModalParams.details[d].deleted == false && costPrice == '' ) {
          isDis = 'false';
        }*/

          if( this.globalModalParams.details[d].deleted == false && this.globalModalParams.details[d].bw_code == '' && this.globalModalParams.departmentId != 20 ) {
            isDis = 'false';
            //console.log('Three');
          }

          /*if( this.fncInputEx(this.globalModalParams.details[d]) == true && this.globalModalParams.details[d].deleted == false && this.globalModalParams.details[d].markup <= 0  ){
            isDis = 'false';
          }*/

          if( this.fncInputEx(this.globalModalParams.details[d]) == true && this.globalModalParams.details[d].deleted == false && this.globalModalParams.details[d].cost_price <= 0  ){
            isDis = 'false';
          }

          if( this.globalModalParams.details[d].deleted == false && this.globalModalParams.details[d].markup.indexOf('-') != '-1' ) {
            isDis = 'false';
           // console.log('Four');
          }
          var costPrice = 0;
          if( this.globalModalParams.details[d].cost_price ) {
            costPrice = String( this.globalModalParams.details[d].cost_price );
          }
          if( this.globalModalParams.details[d].deleted == false && ( costPrice && costPrice.indexOf('-') != '-1' ) ) {
            isDis = 'false';
            //console.log('Five');
          }

        /*if( this.globalModalParams.details[d].deleted == false && ( this.globalModalParams.details[d].price == '0' || this.globalModalParams.details[d].price == '0.00' || this.globalModalParams.details[d].price == '' ) ) {
          console.log( 'Here' );
          console.log( this.globalModalParams.details[d].price );
          isDis = 'false';
        }*/

        /*if( this.globalModalParams.details[d].m2m == undefined || this.globalModalParams.details[d].m2m == false ) {
          if( this.globalModalParams.details[d].deleted == false && ( this.globalModalParams.details[d].cost_price == '0' || this.globalModalParams.details[d].cost_price == '0.00' || this.globalModalParams.details[d].cost_price == '' ) ) {
            isDis = 'false';
          }
        }*/
      }

      this.isDisabled = isDis;

    },
    fncCalculateValues(index, type = ''){

      if( index != undefined ) {

        var marginDisabled = this.fncIsDisabledMargin( this.globalModalParams.details[index] );
        var costDisabled = this.fncIsDisabledCost( this.globalModalParams.details[index] );

        if( type == '' ) {

          this.globalModalParams.details[index].cost_price = ( this.globalModalParams.details[index].price_ex * ( ( 100 - this.globalModalParams.details[index].markup ) / 100 ) );
          this.globalModalParams.details[index].cost_price = this.globalModalParams.details[index].cost_price.toFixed(2);

          var vat = parseFloat( this.globalModalParams.details[index].price_ex * 0.15 );
          this.globalModalParams.details[index].vat = vat;
          this.globalModalParams.details[index].price = parseFloat(this.globalModalParams.details[index].price_ex) + parseFloat(vat);

        } else if( type == 'sales' ) {

          if( this.globalModalParams.details[index].price_ex != '' && this.globalModalParams.details[index].price_ex != '0' && this.globalModalParams.details[index].price_ex != '0.00' ) {
            if( marginDisabled == true ) {
              this.globalModalParams.details[index].cost_price = ( this.globalModalParams.details[index].price_ex * ( ( 100 - this.globalModalParams.details[index].markup ) / 100 ) );
              this.globalModalParams.details[index].cost_price = this.globalModalParams.details[index].cost_price.toFixed(2)
            } else if( costDisabled == true ) {
              this.globalModalParams.details[index].cost_price = ( this.globalModalParams.details[index].price_ex * ( ( 100 - this.globalModalParams.details[index].markup ) / 100 ) );
              this.globalModalParams.details[index].cost_price = this.globalModalParams.details[index].cost_price.toFixed(2)
              // here
            } else {

              var margin = ( this.globalModalParams.details[index].cost_price * 100 ) / this.globalModalParams.details[index].price_ex;
              margin = 100 - margin;

              this.globalModalParams.details[index].markup = margin.toFixed(2);
            }

            /*           var vat = this.globalModalParams.details[index].price_ex - ( this.globalModalParams.details[index].price_ex / 1.15 )
                           vat = parseFloat( vat );*/
            var vat = parseFloat( this.globalModalParams.details[index].price_ex * 0.15 );
            this.globalModalParams.details[index].vat = vat;
            this.globalModalParams.details[index].price = parseFloat(this.globalModalParams.details[index].price_ex) + parseFloat(vat);
          }

        } else if( type == 'cost' ) {

          if( marginDisabled == true ) {

            var sellingPrice = this.globalModalParams.details[index].cost_price / ( 1 - ( this.globalModalParams.details[index].markup / 100 ) )
            this.globalModalParams.details[index].price_ex = sellingPrice.toFixed(2);

          } else {
            var margin = 100 - ( ( this.globalModalParams.details[index].cost_price * 100 ) / this.globalModalParams.details[index].price_ex );
            this.globalModalParams.details[index].markup = margin.toFixed(2);
          }

          var vat = parseFloat( this.globalModalParams.details[index].price_ex * 0.15 );
          this.globalModalParams.details[index].vat = vat;
          this.globalModalParams.details[index].price = parseFloat(this.globalModalParams.details[index].price_ex) + parseFloat(vat);

        } else if( type == 'margin' ) {

          this.globalModalParams.details[index].cost_price = ( this.globalModalParams.details[index].price_ex * ( ( 100 - this.globalModalParams.details[index].markup ) / 100 ) );
          this.globalModalParams.details[index].cost_price = this.globalModalParams.details[index].cost_price.toFixed(2);

          var vat = parseFloat( this.globalModalParams.details[index].price_ex * 0.15 );
          this.globalModalParams.details[index].vat = vat;
          this.globalModalParams.details[index].price = parseFloat(this.globalModalParams.details[index].price_ex) + parseFloat(vat);

        }

      }

      /*if( type != '' && this.globalModalParams.details[index].cost_price.indexOf('-') != -1 ) {

        this.globalModalParams.details[index].cost_price = 0;
        this.globalModalParams.details[index].price = 0;


      }

      if( type != '' && this.globalModalParams.details[index].price_ex.indexOf('-') != -1 ) {

        this.globalModalParams.details[index].price_ex = 0;
        this.globalModalParams.details[index].price = 0;

      }

      if( type != '' && this.globalModalParams.details[index].markup.indexOf('-') != -1 ) {

        this.globalModalParams.details[index].price = 0;
        this.globalModalParams.details[index].markup = 0;

      }*/


    },
    fncHideModal () {
      this.$store.commit('fncSetEditLoading', false);
      this.$store.commit('hideModal');
      //window.location.reload();
    },
    fncSetProductCode( index, item, filter = '' ) {

      //this.globalModalParams.details[index].filter = item.filter;

      if( this.isTallisman == true && typeof item.name == 'object' ) {
        item.name = item.name.article_description;
      }

      var code = '';
      var isMade = false;

      if( item.calculator == '' || ( item.calculator != 'm2m' && item.calculator != '486539909' )) {

        if (this.calculatorFilters.length > 0) {

          var calculatorItems = [];
          var itemRefs = [];

          var zeroPad = (num, places) => String(num).padStart(places, '0');
          for (var c in this.calculatorFilters) {
            if ( this.calculatorFilters[c].rangeId == item.calculator ) {

              for( var i in this.calculatorFilters[c].items ) {

                if( item.calc_name ) {
                  var itemName = item.calc_name.split('||');
                } else {
                  var itemName = '';
                }


                var itemCode = zeroPad( this.calculatorFilters[c].items[i].article, 18 );

                if( this.calculatorFilters[c].items[i].article == itemName[1] ) {
                  // if( itemCode == item.bw_code ) {

                  var zeroPad = (num, places) => String(num).padStart(places, '0');
                  var bwArticle = zeroPad( this.calculatorFilters[c].items[i].article, 18 );

                  this.$store.dispatch('fncGetVendor', this.calculatorFilters[c].items[i].article);

                  this.globalModalParams.details[index].name = itemName[0];;
                  this.globalModalParams.details[index].code = this.calculatorFilters[c].items[i].article;
                  this.globalModalParams.details[index].bw_code = bwArticle;
                  this.globalModalParams.details[index].name_sub = this.calculatorFilters[c].items[i].article_description;
                  this.globalModalParams.details[index].image = this.calculatorFilters[c].items[i].image;
                  this.globalModalParams.details[index].price = this.calculatorFilters[c].items[i].price;
                  this.globalModalParams.details[index].uom = this.calculatorFilters[c].items[i].uom;

                      this.globalModalParams.details[index].disabled = false;

                  //var itemVat = this.calculatorFilters[c].items[i].price * 0.15;
                  var itemVat = this.calculatorFilters[c].items[i].price - ( this.calculatorFilters[c].items[i].price / 1.15  );
                  var priceEx = this.calculatorFilters[c].items[i].price - itemVat;

                  this.globalModalParams.details[index].vat = itemVat;

                  this.globalModalParams.details[index].price_ex = priceEx;

                  if( this.calculatorFilters[c].items[i].purchase_method == 'm2m' ) {

                    isMade = true;
                    this.globalModalParams.details[index].m2m = true;

                    this.globalModalParams.details[index].vat = '0';
                    this.globalModalParams.details[index].price = '0';
                    this.globalModalParams.details[index].price_ex = '0';

                    var lineItemData = JSON.parse(this.globalModalParams.details[index].line_item_data);
                    lineItemData.m2m = true;

                    this.globalModalParams.details[index].line_item_data = JSON.stringify( lineItemData );

                  } else {
                    this.globalModalParams.details[index].m2m = false;

                    var lineItemData = JSON.parse(this.globalModalParams.details[index].line_item_data);
                    lineItemData.m2m = false;

                    this.globalModalParams.details[index].line_item_data = JSON.stringify( lineItemData );
                  }

                  if( this.calculatorFilters[c].items[i].purchase_method == 'm2m' ) {
                    this.globalModalParams.details[index].m2m_calculator = true;
                  } else {
                    this.globalModalParams.details[index].m2m_calculator = false;
                  }

                }
              }

            }
          }
        }

      } else {

        isMade = true;
        for( var p in this.finalPlistItems ) {

          if( this.finalPlistItems[p].article_description == item.name ) {


              if( this.isTallisman == false ) {
                //this.finalPlistItems[p].disabled = true;
                //this.finalPlistItems[i].disabled = false;
              }

            this.globalModalParams.details[index].code = this.finalPlistItems[p].article_number;
            this.globalModalParams.details[index].bw_code = this.finalPlistItems[p].article_number;

            if( this.isTallisman == false ) {
              this.globalModalParams.details[index].name_sub = this.finalPlistItems[p].article_description;
            }

            this.globalModalParams.details[index].m2m = true;
            if( this.itemRefs[this.finalPlistItems[p].article_number] != undefined ) {
              this.globalModalParams.details[index].image = this.itemRefs[this.finalPlistItems[p].article_number];
            } else {
              this.globalModalParams.details[index].image = 'https://cdn.ndtec.co.za/productmedia/builders_warehouse/no_image.jpg';
            }
          }
        }
      }

      var checkUsage = [];
      for( var i in this.globalModalParams.details ) {
        if( this.globalModalParams.details[i].deleted == false ) {
          checkUsage[this.globalModalParams.details[i].code] = this.globalModalParams.details[i].code;
          checkUsage[this.globalModalParams.details[i].bw_code] = this.globalModalParams.details[i].bw_code;
        }
      }

        for( var i in this.finalPlistItems ) {
          if( this.isTallisman == false ) {
            if(checkUsage[this.finalPlistItems[i].article_number] != undefined) {
              // this.finalPlistItems[i].disabled = true;
              //this.finalPlistItems[i].disabled = false;
            } else {
              //this.finalPlistItems[i].disabled = false;
            }
          }
        }

      if( isMade == true ) {

        var hasMargin = false;

        // need to check if the article number has a set number
        if( this.loadedDepartment.article_margins != undefined && this.loadedDepartment.article_margins != null && this.loadedDepartment.article_margins != '' ){

          var zeroPad = (num, places) => String(num).padStart(places, '0');
          var margins = JSON.parse(this.loadedDepartment.article_margins);

          for( var m in margins ) {
            var zeroArticle = zeroPad( margins[m].article, 18 )
            if( margins[m].article == this.globalModalParams.details[index].code || zeroArticle == this.globalModalParams.details[index].code  ) {

              hasMargin = true;

              if( margins[m].margin && margins[m].margin != '' && margins[m].margin != 'null' && margins[m].margin != null ) {
                this.globalModalParams.details[index].markup = margins[m].margin;
              } else if( this.globalModalParams.details[index].is_install != undefined && this.globalModalParams.details[index].is_install == false && this.loadedDepartment.department_margin != '' && this.loadedDepartment.department_margin != '0' ) {
                this.globalModalParams.details[index].markup = this.loadedDepartment.department_margin;
              } else if( this.globalModalParams.details[index].is_install != undefined && this.globalModalParams.details[index].is_install == true && this.loadedDepartment.department_installation_margin != '' && this.loadedDepartment.department_installation_margin != '0' ) {
                this.globalModalParams.details[index].markup = this.loadedDepartment.department_installation_margin;
              }
            }
          }

        }

        if( hasMargin == false ) {
          if( this.globalModalParams.details[index].is_install != undefined && this.globalModalParams.details[index].is_install == false && this.loadedDepartment.department_margin != '' && this.loadedDepartment.department_margin != '0' ) {
            this.globalModalParams.details[index].markup = this.loadedDepartment.department_margin;
          } else if( this.globalModalParams.details[index].is_install != undefined && this.globalModalParams.details[index].is_install == true && this.loadedDepartment.department_installation_margin != '' && this.loadedDepartment.department_installation_margin != '0' ) {
            this.globalModalParams.details[index].markup = this.loadedDepartment.department_installation_margin;
          }
        }

        this.fncCanSave( index, 'sales' );
      } else {
        this.fncCanSave();
      }

      console.log('Changed After');
      console.log( this.globalModalParams.details[index].filter );
    },
    fncRecalculateCodeList() {

      this.fncCanSave();
      /*var removeCodes = [];

      for( var gp in this.globalModalParams.details ) {
        removeCodes.push( this.globalModalParams.details[gp].code );
      }

      var setProductCodes = [];

      for( var pc in this.productCodes ) {
        if( removeCodes.indexOf(this.productCodes[pc].product_code) == -1 ){
          setProductCodes.push( this.productCodes[pc] );
        }
      }

      this.productCodesSet = setProductCodes;*/

    },
    fncGetLabel( currentValue ) {
      if( currentValue != '' ) {
        return currentValue;
      } else {
        return 'Code';
      }
    },
    fncSaveItems() {

      var deleteCount = 0;

      for( var g in this.globalModalParams.details ) {

        if( this.globalModalParams.details[g].price_ex == '0' || this.globalModalParams.details[g].price_ex == '0.00' ) {
          this.globalModalParams.details[g].deleted = true;
        }
        if( this.globalModalParams.details[g].bw_code == '' || this.globalModalParams.details[g].bw_code == '0' ) {
          this.globalModalParams.details[g].name = this.globalModalParams.details[g].name_sub;
        } else {
          if( this.globalModalParams.details[g].name_sub && this.globalModalParams.details[g].name_sub != '' ) {
            this.globalModalParams.details[g].name = this.globalModalParams.details[g].name + ': ' + this.globalModalParams.details[g].name_sub.trim();
          } else {
            this.globalModalParams.details[g].name = this.globalModalParams.details[g].name;
          }
        }

        var lineItemData = JSON.parse(this.globalModalParams.details[g].line_item_data);
        lineItemData.markup = this.globalModalParams.details[g].markup;

        this.globalModalParams.details[g].line_item_data = JSON.stringify( lineItemData );

      }

      for( var g in this.globalModalParams.details ) {
        if( this.globalModalParams.details[g].deleted == true ) {
          deleteCount++;
        }
      }

      if( this.globalModalParams.details.length == deleteCount ) {
        this.fncAddRow();
      }

      var address = [];

      if( this.isTallisman == true ) {
        address['addressOne'] = this.addressOne;
        address['addressTwo'] = this.addressTwo;
        address['town'] = this.town;
        address['province'] = this.province;
        address['postalCode'] = this.postalCode;
      }

      this.$store.commit('fncSetEditLoading', false);
      this.$store.dispatch({
        type: 'fncSaveQuoteItems',
        data: this.globalModalParams.details,
        id: this.globalModalParams.id,
        vendorId: this.globalModalParams.vendorId,
        sendHybris: false,
        notes: this.notes + '||' + this.customerAccountType + '||' + this.customerAccountNumber,
        address: address,
        tallisman: this.isTallisman
      })
    },
    fncDeleteItemRow( index, obj ) {
      var nextItem = index + 1;

        var item = confirm("Are you sure you want to remove this item?");
        if (item == true) {
          for( var p in this.finalPlistItems ) {
            if( this.finalPlistItems[p].article_number == this.globalModalParams.details[index].code || this.finalPlistItems[p].article_number == this.globalModalParams.details[index].bw_code ) {
              //this.finalPlistItems[p].disabled = false;
            }
          }
          this.globalModalParams.details[index].deleted = true;
          if( this.globalModalParams.details[nextItem] != undefined && this.globalModalParams.details[nextItem].is_install != undefined && this.globalModalParams.details[nextItem].is_install == true ) {
            if( this.globalModalParams.details[nextItem] != undefined ) {
              this.globalModalParams.details[nextItem].deleted = true;
            }
          }

        if( this.globalModalParams.details[nextItem] != undefined && ( this.globalModalParams.details[nextItem].bw_code == '751226' || this.globalModalParams.details[nextItem].bw_code == '000000000000751226' ) ) {
          if( this.globalModalParams.details[nextItem] != undefined ) {
            this.globalModalParams.details[nextItem].deleted = true;
          }
        }

        this.fncCanSave();

          var isEmpty = true;
          for( var p in this.globalModalParams.details ) {
            if( this.globalModalParams.details[p].deleted == false ) {
              isEmpty = false
            }
          }
          if( isEmpty == true ) {
            this.fncAddRow();
          }
        }
      },
      fncAddInstallationTallisman( type ) {

        this.isDisabled = 'true';
        var storeId = '';
        for( var p in this.globalModalParams.details ) {
          var lineItemData = JSON.parse(this.globalModalParams.details[p].line_item_data);
          if( lineItemData.store_id != undefined && lineItemData.store_id != null && lineItemData.store_id != 'null' ) {
            storeId = lineItemData.store_id;
          }
        }
        if( storeId == '' ) {
          storeId = this.globalModalParams.storeName;
        }
        if( type == 'delivery' ) {
          var lineItemData = JSON.stringify({ 'added_from_screen' : true, 'm2m': true, 'can_edit_ex': true, 'store_id': storeId, 'type': 'set', 'delivery': true });
        } else if( type == 'fuel' ) {
          var lineItemData = JSON.stringify({ 'added_from_screen' : true, 'm2m': true, 'can_edit_ex': true, 'store_id': storeId, 'type': 'set', 'fuel_vat': true });
        } else if( type == 'consumable' ) {
          var lineItemData = JSON.stringify({ 'added_from_screen' : true, 'm2m': true, 'can_edit_ex': true, 'store_id': storeId, 'type': 'set', 'consumable': true });
        }


      var markup = '';

      if( this.loadedDepartment.article_margins != undefined && this.loadedDepartment.article_margins != null && this.loadedDepartment.article_margins != '' ) {

        var zeroPad = (num, places) => String(num).padStart(places, '0');
        var margins = JSON.parse(this.loadedDepartment.article_margins);

        if( margins.length > 0 ) {
          for( var m in margins ) {
            if( '751229' == margins[m].article || '751229' == zeroPad( margins[m].article, 18 )  ) {
              if( margins[m].article != '' && margins[m].article!= 'undefined' ) {
                markup = margins[m].margin;
              }
            }
          }
        }

      }

      if( markup == '' && this.loadedDepartment.department_margin != undefined && this.loadedDepartment.department_margin != '' && this.loadedDepartment.department_margin != '0' ) {
        markup = this.loadedDepartment.department_margin;
      }

        if( type == 'delivery' ) {
          this.globalModalParams.details.push({ name: 'Delivery', edit_current: true, calculator: 'm2m', is_install: false, m2m: true, markup: '5', p_key: '0', bw_code: '751225', type: 'set', id: '', name: 'Delivery', quantity: '1', price: '0',cost_price: '0',price_ex: '0',vat: 0,code: '751225', range_id: '', deleted: false, line_item_data: lineItemData, delivery: true });
        } else if( type == 'fuel' ) {
          this.globalModalParams.details.push({ name: 'Fuel - Vat', edit_current: true, calculator: 'm2m', is_install: false, m2m: true, markup: '5', p_key: '0', bw_code: '751225', type: 'set', id: '', name: 'Fuel - Vat', quantity: '1', price: '0',cost_price: '0',price_ex: '0',vat: 0,code: '751225', uom: 'litre', range_id: '', deleted: false, line_item_data: lineItemData, fuel_vat: true });
        } else if( type == 'consumable' ) {
          this.globalModalParams.details.push({ name: 'Comsumables', edit_current: true, calculator: 'm2m', is_install: false, m2m: true, markup: '5', p_key: '0', bw_code: '751225', type: 'set', id: '', name: 'Consumables', quantity: '1', price: '0',cost_price: '0',price_ex: '0',vat: 0,code: '751225', range_id: '', deleted: false, line_item_data: lineItemData, consumable: true });
        }

      this.fncCanSave();
    },
    fncAddFuelTallisman() {
      this.isDisabled = 'true';
      var storeId = '';
      for( var p in this.globalModalParams.details ) {
        var lineItemData = JSON.parse(this.globalModalParams.details[p].line_item_data);
        if( lineItemData.store_id != undefined && lineItemData.store_id != null && lineItemData.store_id != 'null' ) {
          storeId = lineItemData.store_id;
        }
      }
      if( storeId == '' ) {
        storeId = this.globalModalParams.storeName;
      }
      var lineItemData = JSON.stringify({ 'added_from_screen' : true, 'm2m': true, 'can_edit_ex': true, 'store_id': storeId, 'type': 'set' });

      var markup = '';

      if( this.loadedDepartment.article_margins != undefined && this.loadedDepartment.article_margins != null && this.loadedDepartment.article_margins != '' ) {

        var zeroPad = (num, places) => String(num).padStart(places, '0');
        var margins = JSON.parse(this.loadedDepartment.article_margins);

        if( margins.length > 0 ) {
          for( var m in margins ) {
            if( '787515' == margins[m].article || '787515' == zeroPad( margins[m].article, 18 )  ) {
              if( margins[m].article != '' && margins[m].article!= 'undefined' ) {
                markup = margins[m].margin;
              }
            }
          }
        }

      }

      if( markup == '' && this.loadedDepartment.department_margin != undefined && this.loadedDepartment.department_margin != '' && this.loadedDepartment.department_margin != '0' ) {
        markup = this.loadedDepartment.department_margin;
      }

        this.globalModalParams.details.push({ uom: 'litre', edit_current: true, calculator: 'm2m', is_install: false, m2m: true, markup: markup, p_key: '0', bw_code: '787515', type: 'set', id: '', name: 'Talisman Fuel', quantity: '1', price: '0',cost_price: '0',price_ex: '0',vat: 0,code: '787515', range_id: '', deleted: false, line_item_data: lineItemData, name_sub: 'Fuel' });

      this.fncCanSave();
    },
    fncAddRow() {

      if( this.isTallisman == true ) {

        // loop through the array first
        var newItems = [];

        for( var d in this.globalModalParams.details ) {
          if( this.globalModalParams.details[d].bw_code != '000000000000751229' && this.globalModalParams.details[d].bw_code != '751229' ) {
            newItems.push(this.globalModalParams.details[d]);
          }
        }

        var parentPkey = '';
        var children = [];
        for( var l in this.lookupArray ) {
          if( l != '751223' && l != '751229' && l != '751224' ) {
            children.push(this.lookupArray[l][0].p_key);
          } else if( l == '751223' ) {
            parentPkey = this.lookupArray[l][0].p_key;
          }
        }

        var strChildren = children.join(',');

        var z = 0;

        var group_item = new Date().getTime();

        for( var i in this.finalPlistItems ) {

          if( this.finalPlistItems[i].article_number != '000000000000751229' && this.finalPlistItems[i].article_number != '751229' ) {

            this.isDisabled = 'true';
            var storeId = '';
            for( var p in this.globalModalParams.details ) {
              var lineItemData = JSON.parse(this.globalModalParams.details[p].line_item_data);
              if( lineItemData.store_id != undefined && lineItemData.store_id != null && lineItemData.store_id != 'null' ) {
                storeId = lineItemData.store_id;
              }
            }
            if( storeId == '' ) {
              storeId = this.globalModalParams.storeName;
            }

            if( z == '0' ) {
              var lineItemData = JSON.stringify({ 'filter': '', 'store_id': storeId, 'type': 'set', 'parent_prop': '', 'group_item': group_item, 'v_key': '' });
            } else {
              var lineItemData = JSON.stringify({ 'filter': '', 'store_id': storeId, 'type': 'set', 'parent_prop': parentPkey, 'group_item': group_item, 'v_key': '' });
            }

            var today = new Date();
            var dd = today.getDate();

            var mm = today.getMonth()+1;
            var yyyy = today.getFullYear();
            if(dd<10) { dd='0'+dd; }

            if(mm<10)  { mm='0'+mm; }

            today = yyyy + '-' + mm + '-' + dd;

            var markup = '';

            if( this.loadedDepartment.article_margins != undefined && this.loadedDepartment.article_margins != null && this.loadedDepartment.article_margins != '' ) {

              var zeroPad = (num, places) => String(num).padStart(places, '0');
              var margins = JSON.parse(this.loadedDepartment.article_margins);

              if( margins.length > 0 ) {
                for( var m in margins ) {
                  if( this.finalPlistItems[i].article_number == margins[m].article || this.finalPlistItems[i].article_number == zeroPad( margins[m].article, 18 )  ) {
                    if( margins[m].article != '' && margins[m].article!= 'undefined' ) {
                      markup = margins[m].margin;
                    }
                  }
                }
              }

            }

            if( markup == '' && this.loadedDepartment.department_margin != undefined && this.loadedDepartment.department_margin != 'undefined' && this.loadedDepartment.department_margin != '' && this.loadedDepartment.department_margin != '0' ) {
              markup = this.loadedDepartment.department_margin;
            }

            if( markup == '' ) {
              markup = 0;
            }

            if( this.lookupArray[parseInt(this.finalPlistItems[i].article_number)] != undefined && this.finalPlistItems[i].article_number != '000000000000751224' && this.finalPlistItems[i].article_number != '000000000000751225' ) {

              /*if( z == '0' ) {
                newItems.push({ edit_current: true, calculator: 'm2m', is_install: false, m2m: true, markup: markup, deleted: false, linked_props: strChildren, p_key: this.lookupArray[parseInt(this.finalPlistItems[i].article_number)][0].p_key, hire_date_start: today, hire_date_end: today, hire_period: '1', bw_code: '', type: 'set', id: '', name: this.finalPlistItems[i].article_description, quantity: '1', price: '0',cost_price: '0',price_ex: '0',uom: 'day',vat: 0,code: '', range_id: '', deleted: false, line_item_data: lineItemData });
              } else {
                newItems.push({ edit_current: true, calculator: 'm2m', is_install: false, m2m: true, markup: markup, deleted: false, linked_props: '', p_key: this.lookupArray[parseInt(this.finalPlistItems[i].article_number)][0].p_key, hire_date_start: today, hire_date_end: today, hire_period: '1', bw_code: '', type: 'set', id: '', name: this.finalPlistItems[i].article_description, quantity: '1', price: '0',cost_price: '0',price_ex: '0',uom: 'each',vat: 0,code: '', range_id: '', deleted: false, line_item_data: lineItemData });
              }*/
              if( z == '0' ) {
                newItems.push({ filter: '', edit_current: true, calculator: 'm2m', is_install: false, m2m: true, markup: markup, deleted: false, linked_props: strChildren, p_key: this.lookupArray[parseInt(this.finalPlistItems[i].article_number)][0].p_key, hire_date_start: today, hire_date_end: today, hire_period: '1', bw_code: this.finalPlistItems[i].article_number, type: 'set', id: '', name: this.finalPlistItems[i].article_description, quantity: '1', price: '0',cost_price: '0',price_ex: '0',uom: 'day',vat: 0,code: '', range_id: '', deleted: false, line_item_data: lineItemData });
              } else {
                newItems.push({ filter: '', edit_current: true, calculator: 'm2m', is_install: false, m2m: true, markup: markup, deleted: false, linked_props: '', p_key: this.lookupArray[parseInt(this.finalPlistItems[i].article_number)][0].p_key, hire_date_start: today, hire_date_end: today, hire_period: '1', bw_code: this.finalPlistItems[i].article_number, type: 'set', id: '', name: this.finalPlistItems[i].article_description, quantity: '1', price: '0',cost_price: '0',price_ex: '0',uom: 'each',vat: 0,code: '', range_id: '', deleted: false, line_item_data: lineItemData });
              }

              z++;
            }


          }

        }

        for( var d in this.globalModalParams.details ) {
          if( this.globalModalParams.details[d].bw_code == '000000000000751229' || this.globalModalParams.details[d].bw_code == '751229' ) {
            newItems.push(this.globalModalParams.details[d]);
          }
        }

        this.globalModalParams.details = newItems;

        // do colours
        var colours = ['#FFFFFF', '#E8E8E8','#FFFFFF', '#E8E8E8','#FFFFFF', '#E8E8E8','#FFFFFF', '#E8E8E8'];
        var currentGroup = '0';
        var n = 0;
        for( var p in this.globalModalParams.details ) {

          var lineItemData = JSON.parse(this.globalModalParams.details[p].line_item_data);

          if( lineItemData.group_item != undefined && lineItemData.group_item != currentGroup  ) {
            currentGroup = lineItemData.group_item;
            n++;
            this.globalModalParams.details[p].colour = colours[n-1];
          } else {
            this.globalModalParams.details[p].colour = colours[n-1];
          }

          if( this.globalModalParams.details[p].bw_code == '000000000000751229' || this.globalModalParams.details[p].bw_code == '751229' ) {
            currentGroup = 'delivery';
            n++;
            this.globalModalParams.details[p].colour = colours[n-1];
          }

          // this.globalModalParams.details[p].filter = 'code_primer';

        }

        //this.globalModalParams.details.push();

        this.fncCanSave();

      } else {
        this.isDisabled = 'true';
        var storeId = '';
        for( var p in this.globalModalParams.details ) {
          var lineItemData = JSON.parse(this.globalModalParams.details[p].line_item_data);
          if( lineItemData.store_id != undefined && lineItemData.store_id != null && lineItemData.store_id != 'null' ) {
            storeId = lineItemData.store_id;
          }
        }
        if( storeId == '' ) {
          storeId = this.globalModalParams.storeName;
        }
        var lineItemData = JSON.stringify({ 'added_from_screen' : true, 'm2m': true, 'can_edit_ex': true, 'store_id': storeId, 'type': 'set' });

        var markup = '0';
        if( this.loadedDepartment.department_margin != '' && this.loadedDepartment.department_margin != '0' ) {
          markup = this.loadedDepartment.department_margin;
        }

        this.globalModalParams.details.push({ filter: '', edit_current: true, calculator: 'm2m', is_install: false, m2m: true, markup: markup, p_key: '0', bw_code: 0, type: 'set', id: '', name: 'Default', quantity: '1', price: '0',cost_price: '0',price_ex: '0',vat: 0,code: '', range_id: '', deleted: false, line_item_data: lineItemData });
        //this.globalModalParams.details.push({ id: '', name: '', quantity: '1', price: '0',cost_price: '0',code: '', range_id: '', deleted: false, line_item_data: lineItemData });

        this.fncCanSave();

      }

    },
    fncAddRowFree() {
      this.isDisabled = 'true';
      var storeId = '';
      for( var p in this.globalModalParams.details ) {
        var lineItemData = JSON.parse(this.globalModalParams.details[p].line_item_data);
        if( lineItemData.store_id != undefined && lineItemData.store_id != null && lineItemData.store_id != 'null' ) {
          storeId = lineItemData.store_id;
        }
      }
      var lineItemData = JSON.stringify({ 'store_id': storeId, 'type': 'free' });
      this.globalModalParams.details.push({ filter: '', bw_code: 0, type: 'free', id: '', name: '', quantity: '1', price: '0',cost_price: '0',price_ex: '0',vat: 0,code: '', range_id: '', deleted: false, line_item_data: lineItemData });

    },
  },
  computed: {
    ...mapGetters([
      'objAuthorize',
      'globalModalParams',
      'surveyProductCodes',
      'vendorList',
      'statusList',
      'departmentList',
      'departmentRangesList',
      'calculatorFilters',
      'spineLoading',
      'vendorListCodes',
      'lookupArray'
      //'singleQuoteData'
    ])
  },
  components: {
    DatePicker
  },
  beforeMount() {
    this.$store.dispatch('fncPopulateProductCodes');
    this.$store.dispatch('fncPopulateVendors');
  },
  mounted() {

    for( var d in this.globalModalParams.details ) {
      if( !this.globalModalParams.details[d].filter || this.globalModalParams.details[d].filter == 'undefined' || this.globalModalParams.details[d].filter == undefined ) {
        this.globalModalParams.details[d].filter = '';
      }
    }

    this.addressOne = this.globalModalParams.details[0].address_one;
    this.addressTwo = this.globalModalParams.details[0].address_two;

    var deliveryDate = '';

    if( this.globalModalParams.details[0].notes != 'null' && this.globalModalParams.details[0].notes != null ) {
      var notesSplit = this.globalModalParams.details[0].notes.split('||');

      this.notes = notesSplit[0];
      this.customerAccountType = notesSplit[1];
      this.customerAccountNumber = notesSplit[2];
    }

    if( this.globalModalParams.details[0].town != undefined ) {
      var townSplit = this.globalModalParams.details[0].town.split('||');

      this.town = townSplit[0];
      this.province = townSplit[1];
    }
    this.postalCode = this.globalModalParams.details[0].postal_code;

    if( this.globalModalParams.details.length == 1 && this.globalModalParams.details[0].price == '0' ) {
      var lineItemData = JSON.parse(this.globalModalParams.details[0].line_item_data);
      if( lineItemData.added_from_screen == undefined ) {
        lineItemData.added_from_screen = true;
        this.globalModalParams.details[0].line_item_data = JSON.stringify( lineItemData );
      }
      this.globalModalParams.details[0].edit_current = true;
    } else {
      this.globalModalParams.details[0].edit_current = false;
    }

    var zeroPad = (num, places) => String(num).padStart(places, '0');

    for( var d in this.departmentList ) {
      if( this.departmentList[d].id == this.globalModalParams.departmentId ) {
        this.departmentMargin = this.departmentList[d].department_margin;
        this.departmentInstallationMargin = this.departmentList[d].department_installation_margin;

        if( this.departmentList[d].product_codes.length > 0 ){
          for( var p in this.departmentList[d].product_codes ) {
            this.productCodes.push(this.departmentList[d].product_codes[p].value);
            this.productCodes.push(zeroPad( this.departmentList[d].product_codes[p].value, 18 ));
          }
        }

        this.canInstall = true;

        /*if( this.departmentList[d].installation_articles != null && this.departmentList[d].installation_articles != '' ) {
          this.canInstall = false;
        } else {
          this.canInstall = true;
        }*/
      }
    }

    this.$store.dispatch('fncGetQuoteCodes', this.globalModalParams.details[0].quote );

    var installations = JSON.parse( this.objAuthorize.installations );
    var manualInstallations = JSON.parse( this.objAuthorize.manual_installations );

    var objInstallations = [];
    for( var i in installations ) {
      objInstallations.push(installations[i].code);
    }
    for( var i in manualInstallations ) {
      objInstallations.push(manualInstallations[i].code);
      objInstallations.push(zeroPad( manualInstallations[i].code, 18 ));
    }

    var storeId = '';
    var type = '';

    var department = this.globalModalParams.departmentId;

    for( var d in this.departmentList ) {
      if( this.departmentList[d].id == department ) {
        this.loadedDepartment = this.departmentList[d];

        this.$store.dispatch({
          type: 'fncUsableBranches'
        })
      }
    }

    for( var d in this.departmentList ) {
      if( this.departmentList[d].id == this.globalModalParams.departmentId ) {
        this.rangeFilters = JSON.parse( this.departmentList[d].range_filters );
      }
    }

    for( var p in this.globalModalParams.details ) {

      // this.globalModalParams.details[p].filter = 'code_primer';

      if( deliveryDate == '' && this.globalModalParams.details[p].hire_period != 'NaN' ) {
        deliveryDate = this.globalModalParams.details[p].hire_date_start;
      }

      if( this.globalModalParams.details[p].bw_code == '751225' || this.globalModalParams.details[p].bw_code == '000000000000751225' ) {

        if( this.globalModalParams.details[p].hire_period == 'NaN' || this.globalModalParams.details[p].hire_period == '' ){

          var lineItemData = JSON.parse(this.globalModalParams.details[p].line_item_data);

          lineItemData.delivery = true;
          this.globalModalParams.details[p].line_item_data = JSON.stringify( lineItemData );

          /*this.globalModalParams.details[p].hire_date_start = deliveryDate;
          this.globalModalParams.details[p].hire_date_end = deliveryDate;
          this.globalModalParams.details[p].hire_period = 1;*/
        }
      }

      // deliveryDate

      if( this.globalModalParams.details[p].range_id != '0' && this.globalModalParams.details[p].range_id != '' && this.globalModalParams.details[p].range_id != 'null' && this.globalModalParams.details[p].range_id != null ) {
        this.globalModalParams.details[p].calculator = this.globalModalParams.details[p].range_id;
      } else if( this.globalModalParams.details[p].range_id == '0' || this.globalModalParams.details[p].calculator == undefined || this.globalModalParams.details[p].calculator == 'undefined' || this.globalModalParams.details[p].calculator == '' || this.globalModalParams.details[p].calculator == '0' ) {
        this.globalModalParams.details[p].calculator = 'm2m';
      }

      if( this.globalModalParams.details[p].spec != '') {
        if( this.globalModalParams.details[p].spec.indexOf("<span class='quotelocation'>") > 0 ) {
          var split = this.globalModalParams.details[p].spec.split("<span class='quotelocation'>");
          split = split[1].split('</span>');
          if( split.length > 1 ) {
            this.globalModalParams.details[p].location = split[0];
          }
        }
      }

      // this.globalModalParams.details[p].edit_current = false;

      //if( this.globalModalParams.details[p].bw_code == '' || this.globalModalParams.details[p].bw_code == '0' ) {
      this.globalModalParams.details[p].bw_code = zeroPad( this.globalModalParams.details[p].code, 18 );
      //}
      var lineItemData = JSON.parse(this.globalModalParams.details[p].line_item_data);
      if( lineItemData.store_id != undefined && lineItemData.store_id != null && lineItemData.store_id != 'null' ) {
        storeId = lineItemData.store_id;
      }
      if( lineItemData.location != undefined && lineItemData.location != null && lineItemData.location != 'null' ) {
        this.globalModalParams.details[p].location = lineItemData.location;
      }
      if( lineItemData.calculator != undefined && lineItemData.calculator != null && lineItemData.calculator != 'null' ) {
        this.globalModalParams.details[p].calculator = lineItemData.calculator;
      }
      if( lineItemData.store_id != undefined && lineItemData.store_id != null && lineItemData.store_id != 'null' ) {
        type = lineItemData.type;
      }
      if( this.globalModalParams.details[p].quantity == '0' ) {
        this.globalModalParams.details[p].quantity = 1;
      }

      if( this.globalModalParams.details[p].cost_price == '(pending)' ) {
        this.globalModalParams.details[p].cost_price = 0;
      }

      if( objInstallations.indexOf(String(parseFloat(this.globalModalParams.details[p].code))) != -1 && objInstallations.indexOf(String(this.globalModalParams.details[p].code)) != -1 || objInstallations.indexOf(String(zeroPad( this.globalModalParams.details[p].code, 18 ))) != -1 ) {
        this.globalModalParams.details[p].is_install = true;

      } else {
        this.globalModalParams.details[p].is_install = false;
      }

      if( this.globalModalParams.details[p].price != '0' && this.globalModalParams.details[p].quantity != '0' && this.globalModalParams.details[p].price_ex ) {

        var vat = ( this.globalModalParams.details[p].price / 115 ) * 15;
        //var vat = ( this.globalModalParams.details[p].price / 100 ) * 15;

        var price = this.globalModalParams.details[p].price - vat;

        var updatePrice = this.fncCheckDisabled(this.globalModalParams.details[p].p_key);

        if( updatePrice == true ) {
          this.globalModalParams.details[p].price_ex = parseFloat(price).toFixed(2);
        }

        if( updatePrice == true ) {
          this.globalModalParams.details[p].vat = parseFloat(vat).toFixed(2);
        }

        //this.globalModalParams.details[p].markup = this.loadedDepartment.department_installation_margin;
        //this.globalModalParams.details[p].markup = parseFloat(this.loadedDepartment.department_installation_margin);

      }

      if( lineItemData.markup != undefined && lineItemData.markup != '' ) {
        this.globalModalParams.details[p].markup = lineItemData.markup;

      } else if( this.globalModalParams.details[p].cost_price != '0' && this.globalModalParams.details[p].cost_price != '' ) {

        var markup = ( this.globalModalParams.details[p].cost_price * 100 ) / this.globalModalParams.details[p].price_ex;
        markup = 100 - markup;

        this.globalModalParams.details[p].markup = markup.toFixed(2);

      } else if( this.globalModalParams.details[p].is_install == false && this.loadedDepartment.department_margin != '' && this.loadedDepartment.department_margin != '0' ) {

        if( this.loadedDepartment.article_margins != '' && this.loadedDepartment.article_margins != 'null' && this.loadedDepartment.article_margins != null ) {

          var articleMargins = JSON.parse( this.loadedDepartment.article_margins );

          var markup = '';
          if( articleMargins.length > 0 ) {

            for( var m in articleMargins ) {

              var bwArticle = zeroPad(articleMargins[m].article, 18);

              if( this.globalModalParams.details[p].bw_code == articleMargins[m].article || this.globalModalParams.details[p].bw_code == bwArticle ) {
                markup = articleMargins[m].margin;
                this.globalModalParams.details[p].markup = markup;
              }

            }

            if( markup == '' ) {
              this.globalModalParams.details[p].markup = this.loadedDepartment.department_margin;
            }

          } else {
            this.globalModalParams.details[p].markup = this.loadedDepartment.department_margin;
          }
        } else {
          this.globalModalParams.details[p].markup = this.loadedDepartment.department_margin;
        }
      } else if( this.globalModalParams.details[p].is_install == true && this.loadedDepartment.department_installation_margin != '' && this.loadedDepartment.department_installation_margin != '0' ) {
        this.globalModalParams.details[p].markup = this.loadedDepartment.department_installation_margin;

      }

      this.globalModalParams.details[p].m2m = false;

      if( this.globalModalParams.details[p].cost_price == '0' ) {
        var marginPercentage = 0.2;
        if( this.globalModalParams.details[p].price != '0' ) {

          if( this.productCodes.indexOf(this.globalModalParams.details[p].code) == -1 ) {
            this.globalModalParams.details[p].m2m = false;
          } else {

            // ok we need to check whether its installation or not
            if( this.globalModalParams.details[p].is_install == true ) {
              var departmentMargin = ( 100 - this.departmentInstallationMargin ) / 100;
              this.globalModalParams.details[p].setMargin = this.departmentInstallationMargin;
            } else {
              // var departmentMargin = ( 100 - this.departmentMargin ) / 100;
              var departmentMargin = ( 100 - this.globalModalParams.details[p].markup ) / 100;
              this.globalModalParams.details[p].setMargin = this.globalModalParams.details[p].markup;
            }

            var costPrice = this.globalModalParams.details[p].price_ex * departmentMargin;

            this.globalModalParams.details[p].cost_price = parseFloat(costPrice).toFixed(2);
          }

        }
      }

      /*var items = this.fncGetNames();

      console.log('Items');
      console.log( items );
      for( var i in items ) {
        console.log(items[i]);
      }
      console.log('Name');*/

      /*if( lineItemData.cost_price != undefined ) {
        this.globalModalParams.details[p].cost_price = lineItemData.cost_price;
      } else {
        this.globalModalParams.details[p].cost_price = 0;
      }
      if( lineItemData.price_ex != undefined ) {
        this.globalModalParams.details[p].price_ex = lineItemData.price_ex;
      } else {
        this.globalModalParams.details[p].price_ex = 0;
      }*/
      /*if( lineItemData.price_ex != '' && lineItemData.price_ex != '0' && lineItemData.cost_price != '' && lineItemData.cost_price != '0' ) {
        this.globalModalParams.details[p].markup = ( ( lineItemData.cost_price * 100 ) / lineItemData.price_ex ) + '%';
      } else {
        this.globalModalParams.details[p].markup = 0;
      }*/
    }

    for( var p in this.globalModalParams.details ) {

      var lineItemData = JSON.parse(this.globalModalParams.details[p].line_item_data);

      //if( this.productCodes.indexOf(this.globalModalParams.details[p].code) != -1 || lineItemData.m2m != undefined || this.globalModalParams.details[p].calculator == 'm2m' ) {
      //if( this.productCodes.indexOf(this.globalModalParams.details[p].code) != -1 || this.globalModalParams.details[p].calculator == 'm2m' ) {
      if( this.productCodes.indexOf(this.globalModalParams.details[p].code) != -1 ) {
        this.globalModalParams.details[p].m2m = true;
      } else if( this.globalModalParams.details[p].calculator == 'm2m' ) {
        this.globalModalParams.details[p].m2m = true;
      }



      if( lineItemData.store_id == undefined || lineItemData.store_id == null || lineItemData.store_id == 'null' ) {
        lineItemData.store_id  = storeId;
        this.globalModalParams.details[p].line_item_data = JSON.stringify( lineItemData );
      }

      if( lineItemData.markup == undefined || lineItemData.markup == null || lineItemData.markup == 'null' ) {
        if( this.isTallisman == false ) {
          lineItemData.markup = '';
          this.globalModalParams.details[p].line_item_data = JSON.stringify( lineItemData );
        }
      }
      this.globalModalParams.details[p].type = type;

      if( this.globalModalParams.details[p].m2m != true ) {
        var lineItemData = JSON.parse(this.globalModalParams.details[p].line_item_data);
        lineItemData.can_edit_ex = true;
        this.globalModalParams.details[p].line_item_data = JSON.stringify( lineItemData );
      }

      this.globalModalParams.details[p].location_drop = this.globalModalParams.details[p].location;

      if( this.globalModalParams.details[p].location_drop == undefined || this.globalModalParams.details[p].location_drop == 'undefined' ) {
        this.globalModalParams.details[p].location_drop = '';
      }

    }

    var usedCodes = [];
    for( var d in this.globalModalParams.details ) {
      usedCodes.push( this.globalModalParams.details[d].bw_code );
    }

    this.$store.dispatch('fncGetVendorAll', usedCodes);

    this.fncCanSave();

    if( this.globalModalParams.details[0].price == '0' && this.globalModalParams.details[0].bw_code == '' ) {
      this.globalModalParams.details = [];
    }

    for( var g in this.globalModalParams.details ) {

      if( this.globalModalParams.details[g].bw_code == '' || this.globalModalParams.details[g].bw_code == '0' ) {
        this.globalModalParams.details[g].name_sub = this.globalModalParams.details[g].name
      } else {

        var regexForHTML = /<([A-Za-z][A-Za-z0-9]*)\b[^>]*>(.*?)<\/\1>/;
        var isValid = regexForHTML.test(this.globalModalParams.details[g].name);

        if( isValid == true ) {

          this.globalModalParams.details[g].name = this.globalModalParams.details[g].name.replace(/<[^>]*>/g, ' ');
          this.globalModalParams.details[g].name_sub = this.globalModalParams.details[g].name.replace(/<[^>]*>/g, ' ');

        } else {
          var nameSplit = this.globalModalParams.details[g].name.split(':');

          if( nameSplit.length > 1 ) {

            if( nameSplit.length > 2 ) {

              var newSubName = [];
              var n = 0;
              for( var s in nameSplit ) {
                if( n != 0 ) {
                  newSubName.push(nameSplit[s]);
                }
                n++;
              }

              newSubName = newSubName.join(': ');

              this.globalModalParams.details[g].name_sub = newSubName;
            } else {
              var subName = nameSplit[nameSplit.length - 1];
              this.globalModalParams.details[g].name_sub = subName;
              var fullName = nameSplit.slice(0,-1);
              this.globalModalParams.details[g].name = fullName[0].trim();
            }

            //this.globalModalParams.details[g].name = fullName.join('-').trim();
          } else {
            this.globalModalParams.details[g].name_sub = nameSplit[0];
          }
        }

      }

    }

    /*if( this.globalModalParams.details[g].m2m == true ) {
      this.globalModalParams.details[g].markup = 0;
    }*/

    // setup headers
    var formFields = JSON.parse(this.loadedDepartment.edit_form_fields);

    if( formFields.calculator == 'true' ) { this.headers.push({ text: 'Calculator', value: 'calculator' });  }
    if( formFields.location == 'true' ) { this.headers.push({ text: 'Location', value: 'location' });  }
    if( formFields.vendor == 'true' ) { this.headers.push({ text: 'Vendor', value: 'vendor' });  }
    if( formFields.articleDescription == 'true' ) { this.headers.push({ text: 'Article Description', value: 'articleDescription' });  }
    if( formFields.bwArticleNo == 'true' ) { this.headers.push({ text: 'BW Article Number', value: 'bwArticleNo' });  }
    if( formFields.plantCode == 'true' ) { this.headers.push({ text: 'Product Code', value: 'plantCode' });  }
    if( formFields.productDescription == 'true' ) { this.headers.push({ text: 'Product Description', value: 'productDescription' });  }
    if( formFields.quantity == 'true' ) { this.headers.push({ text: 'Qty', value: 'quantity' });  }
    if( formFields.uom == 'true' ) { this.headers.push({ text: 'UOM', value: 'uom' });  }
    if( formFields.hireDate == 'true' ) { this.isTallisman = true; this.headers.push({ text: 'Hire Date', value: 'hireDate' });  }
    if( formFields.hirePeriod == 'true' ) { this.isTallisman = true; this.headers.push({ text: 'Hire Period', value: 'hirePeriod' });  }
    if( formFields.deliveryMethod == 'true' ) { this.isTallisman = true; this.headers.push({ text: 'Delivery Method', value: 'deliveryMethod' });  }
    if( formFields.receivalTime == 'true' ) { this.isTallisman = true; this.headers.push({ text: 'Receival Time', value: 'receivalTime' });  }
    if( formFields.unitSellingPriceExVat == 'true' ) { this.headers.push({ text: 'Unit SP (Excl VAT)', value: 'unitSellingPriceExVat' });  }
    if( formFields.unitVat == 'true' ) { this.headers.push({ text: 'Unit Vat', value: 'unitVat' });  }
    if( formFields.unitTotalIncVat == 'true' ) { this.headers.push({ text: 'Unit SP (Inc VAT)', value: 'unitTotalIncVat' });  }
    if( formFields.vendorUnitCostExVat == 'true' ) { this.headers.push({ text: 'Vendor Unit Cost (Excl VAT)', value: 'vendorUnitCostExVat' });  }
    if( formFields.margin == 'true' ) { this.headers.push({ text: 'Margin', value: 'margin' });  }
    if( formFields.totalIncVat == 'true' ) { this.headers.push({ text: 'Total SP (Inc VAT)', value: 'totalIncVat' });  }

    this.headers.push({ text: '', value: '' });

    if( this.isTallisman == true ) {
      this.$store.dispatch('fncPopulateTallisman');
    }

    /*  var installationArticles = [];
     if( this.objAuthorize.installations != null && this.objAuthorize.installations != '' ) {
       var installations = JSON.parse( this.objAuthorize.installations );
       for( var i in installations ) {
         installationArticles[installations[i]['code']] = installations[i]['code'];
       }
     }
     if( this.objAuthorize.manual_installations != null && this.objAuthorize.manual_installations != '' ) {
       var manualInstallations = JSON.parse( this.objAuthorize.manual_installations );
       for( var i in manualInstallations ) {
         installationArticles[manualInstallations[i]['code']] = manualInstallations[i]['code'];
       }
     }

     for( var d in this.globalModalParams.details ) {
       var paddedCode = zeroPad( this.globalModalParams.details[d].code, 18 );
       if( this.globalModalParams.details[d].is_install == true ) {
         this.canInstall = false;
       } else if( installationArticles[this.globalModalParams.details[d].code] != undefined || installationArticles[paddedCode] != undefined ) {
         this.canInstall = false;
       }
     }*/

    if( this.isTallisman == true && this.globalModalParams.details.length == 1 && ( this.globalModalParams.details[0].price == '0' || this.globalModalParams.details[0].price == '0.00' ) ) {
      this.globalModalParams.details[0].deleted = true;
      this.fncAddRow();
    } else if( this.globalModalParams.details.length == 1 && ( this.globalModalParams.details[0].price == '0' || this.globalModalParams.details[0].price == '0.00' ) ) {
      this.globalModalParams.details[0].deleted = true;
      this.fncAddRow();
    }

    for( var d in this.globalModalParams.details ) {
      if( this.globalModalParams.details[d].calculator != 'm2m' ) {
        this.globalModalParams.details[d].m2m = false;
      }
    }

  },
  watch: {
    departmentRangesList() {
      this.departmentRangesListFiltered.push({ id32: 'm2m', name: "Made To Measure" });
      for( var dp in this.departmentRangesList ) {
        if( this.loadedDepartment.ranges.indexOf( this.departmentRangesList[dp].id32 ) != -1 ) {
          this.departmentRangesListFiltered.push(this.departmentRangesList[dp]);
          //this.$store.dispatch('fncFilterLineItems', this.departmentRangesList[dp].id32);
        }
      }
    },
    vendorList() {
      if( this.vendorList.length > 0 ) {
        for( var v in this.vendorList ) {
          // console.log( this.vendorList[v] );
        }
      }
    },
    surveyProductCodes() {

      this.productCodesSet = this.surveyProductCodes;

      var availableCodes = [];
      var availableSpine = [];
      var addedCodes = [];

      for( var p in this.productCodesSet ) {
        if( this.productCodesSet[p].product_code != undefined && this.productCodesSet[p].product_code != null ) {
          var articleNumber = this.productCodesSet[p].product_code.padStart(18, '0');
          availableCodes.push( String( articleNumber ) );
        }
      }

      for( var i in this.globalModalParams.plistItems ) {
        //if( addedCodes.indexOf(String( this.globalModalParams.plistItems[i].article_number )) == -1 && availableCodes.indexOf( String( this.globalModalParams.plistItems[i].article_number ) ) != -1 ) {
        availableSpine.push(this.globalModalParams.plistItems[i]);
        addedCodes.push(this.globalModalParams.plistItems[i].pli_code);
        //}
      }

      var vendorCodesAsc = [];
      if( this.vendorList.length > 0 ) {
        for( var v in this.vendorList ) {
          if( this.vendorList[v].product_codes.length > 0 ) {
            for( var pc in this.vendorList[v].product_codes ) {
              if( this.vendorList[v].product_codes[pc].value != '' ) {

                var paddedValue = this.vendorList[v].product_codes[pc].value.padStart(18, '0');
                vendorCodesAsc[this.vendorList[v].product_codes[pc].value] = this.vendorList[v].name;
                vendorCodesAsc[paddedValue] = this.vendorList[v].name;
              }
            }
          }
        }
      }

      if( availableSpine.length > 0 ) {
        for( var a in availableSpine ) {

          if( vendorCodesAsc[availableSpine[a].article_number] != null ) {
            availableSpine[a].article_description_vendor = vendorCodesAsc[availableSpine[a].article_number] + ': ' + availableSpine[a].article_description;
          } else {
            availableSpine[a].article_description_vendor = availableSpine[a].article_description;
          }

        }
      }

      // var articleNumber = this.productCodesSet[p].product_code.padStart(18, '0');

      this.finalPlistItems = availableSpine;

      var checkUsage = [];
      for( var i in this.globalModalParams.details ) {

        // this.globalModalParams.details[i].items = this.fncFinalItemsFiltered( this.globalModalParams.details[i].is_install, this.globalModalParams.details[i].calculator )

        checkUsage[this.globalModalParams.details[i].code] = this.globalModalParams.details[i].code;
        checkUsage[this.globalModalParams.details[i].bw_code] = this.globalModalParams.details[i].bw_code;

        for( var f in this.finalPlistItems ) {
          if( this.finalPlistItems[f].article_number == this.globalModalParams.details[i].code || this.finalPlistItems[f].article_number == this.globalModalParams.details[i].bw_code ) {
            this.globalModalParams.details[i].name = this.finalPlistItems[f].article_description;
            //this.globalModalParams.details[i].name = this.finalPlistItems[f].article_description_vendor;
          }
        }

      }

        for( var i in this.finalPlistItems ) {
          //if(checkUsage[this.finalPlistItems[i].article_number] != undefined && this.isTallisman == false) {
          if(checkUsage[this.finalPlistItems[i].article_number] != undefined ) {
            // this.finalPlistItems[i].disabled = true;
            this.finalPlistItems[i].disabled = false;
          }
        }

    },
    lookupArray() {

      this.lookupArray['751224'] = this.lookupArray['751223'];

      this.tallismanLoaded = true;
      if( this.isTallisman == true ) {

        var itemLookup = [];
        for( var p in this.finalPlistItems ) {
          itemLookup[this.finalPlistItems[p].article_number] = this.finalPlistItems[p].article_description;
        }
        for( var i in this.globalModalParams.details ) {

          var lineItemData = JSON.parse( this.globalModalParams.details[i].line_item_data );

          if( this.isTallisman == true && lineItemData.hire_period == undefined || lineItemData.hire_period == null || lineItemData.hire_period == 'null' ) {
            this.fncCheckHireDays(i, 'hire_date_start');
            this.fncCheckHireDays(i, 'hire_date_end');
          }

          this.globalModalParams.details[i].code = this.globalModalParams.details[i].code.toString().padStart(18, '0');
          this.globalModalParams.details[i].bw_code = this.globalModalParams.details[i].bw_code.toString().padStart(18, '0');

          if( this.globalModalParams.details[i].oldname != undefined ) {
            var nameSplit = this.globalModalParams.details[i].oldname.split(':');
            if( nameSplit.length == 1 ) {
              this.globalModalParams.details[i].name_sub = this.globalModalParams.details[i].name.trim();
              this.globalModalParams.details[i].name = itemLookup[this.globalModalParams.details[i].code];
            }
          }

        }

        /*if( this.isTallisman == true ) {

          if( this.globalModalParams.details.length == 1 && this.globalModalParams.details[0].price == '0' ) {
            this.globalModalParams.details = [];
            this.fncAddRow();
          }
        }*/

        // presave incase data comes from app
        /*var mainThis = this;
        setTimeout(function(){
          mainThis.fncSaveItems( false );
        }, 2000)*/

      }
      if( this.isTallisman == true && this.globalModalParams.details.length == 1 && ( this.globalModalParams.details[0].price == '0' || this.globalModalParams.details[0].price == '0.00' ) ) {
        this.globalModalParams.details[0].deleted = true;
        this.fncAddRow();
      }
    },
    spineLoading() {

      /*if( this.spineLoading == false ) {
        this.globalModalParams.details[this.setIndex].filter = this.setFilter;
        console.log( this.setFilter );
        console.log(  );
      }*/

    }
    /*productCodes() {

      var removeCodes = [];

      for( var gp in this.globalModalParams.details ) {
        removeCodes.push( this.globalModalParams.details[gp].code );
      }

      var setProductCodes = [];
      for( var pc in this.productCodes ) {
        if( removeCodes.indexOf(this.productCodes[pc].product_code) == -1 ){
          setProductCodes.push( this.productCodes[pc] );
        }
      }

      this.productCodesSet = setProductCodes;
    }*/
  }
}
</script>

<style scoped>
/*@import '../../assets/css/shared.css'*/
</style>
